export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Physical address type representation.
   * Contains the following fields:
   * * country
   * * city
   * * state
   * * streetName
   * * streetNumber
   * * additionalInfo
   * * zipCode
   */
  Address: { input: any; output: any; }
  /** BonusCode to be applied in the checkout */
  BonusCode: { input: string; output: string; }
  /** A phone number country code representation. Must match: `^\+[1-9]\d{0,2}$` */
  CountryCode: { input: string; output: string; }
  /** A customer id which matches the following regular expression: `^[A-Z]{2}-\d{3}-\d{3}-\d{3}$` */
  CustomerId: { input: string; output: string; }
  /** An RFC-3339 compliant Full Date Scalar */
  Date: { input: string; output: string; }
  /** A slightly refined version of RFC-3339 compliant DateTime Scalar */
  DateTime: { input: string; output: string; }
  /** DrawnNumbersGroup used to group drawn numbers of a lottery by name (for example GREENBALL, DOUBLE_DRAW */
  DrawnNumbersGroup: { input: string; output: string; }
  /** An e-mail address which matches the following regular expression: `^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9-]{2,}$` */
  EMailAddress: { input: string; output: string; }
  /** Idempotency key used for deduplication of requests */
  IdempotencyKey: { input: string; output: string; }
  /** ISO 8601 compliant Instant scalar */
  Instant: { input: string; output: string; }
  /** A IETF BCP 47 language tag for an existing country (ISO 3166-1) and language (ISO 639-1). */
  LanguageTag: { input: string; output: string; }
  /** A country as defined in ISO-3166-1-alpha2 (e.g. US) or a country subdivision as defined in ISO 3166-2 (e.g. US-NJ). */
  LicensedTerritory: { input: string; output: string; }
  /** 24-hour clock time value string in the format `hh:mm:ss` or `hh:mm:ss.sss`. */
  LocalTime: { input: string; output: string; }
  /** A 64-bit signed integer */
  Long: { input: number; output: number; }
  /** A name. Must match the regular expression `^[\p{Ll}\p{Lu}][\p{Ll}\p{Lu}'.\- ]{0,38}[\p{Ll}\p{Lu}.]$`. */
  Name: { input: string; output: string; }
  /** The national number part of a phone number. Must match: `^[1-9]\d{4,13}$` */
  NationalNumber: { input: string; output: string; }
  /** OrderId used to identify an order (buy play slip) of a player */
  OrderId: { input: string; output: string; }
  /** ProductId used to identify a particular play slip */
  ProductId: { input: string; output: string; }
  /** human readable subscription code to identify a subscription */
  SubscriptionCode: { input: string; output: string; }
  /** A universally unique identifier compliant UUID Scalar */
  UUID: { input: string; output: string; }
  /** An e-mail address which is not validated against a regular expression. */
  UnvalidatedEMailAddress: { input: string; output: string; }
  /** A valid URL. */
  Url: { input: string; output: string; }
};

/** Account of the owner */
export type AccountPayload = {
  __typename?: 'AccountPayload';
  balance: Money;
  id: Scalars['ID']['output'];
  limits: Limits;
  ownerId: Scalars['String']['output'];
};

export type ActivePlaySlip = PlaySlip & {
  __typename?: 'ActivePlaySlip';
  firstDrawDate: Scalars['DateTime']['output'];
  hasWinnings: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  licensedTerritory: Scalars['String']['output'];
  lotteryId: LotteryId;
  nextDrawDate: Scalars['DateTime']['output'];
  numberOfDraws: Scalars['Int']['output'];
  numberOfPlays: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderedAt: Scalars['DateTime']['output'];
  remainingDraws: Scalars['Int']['output'];
  selectedAddOns: Array<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
  status: PlaySlipStatus;
  /** @deprecated Please check for (optional) subscriptionInfo instead */
  subscription: Scalars['Boolean']['output'];
  subscriptionInfo?: Maybe<SubscriptionInfo>;
  totalWinAmount: Money;
};

export type ActivePlaySlipOrder = PlaySlipOrder & {
  __typename?: 'ActivePlaySlipOrder';
  firstDrawDate: Scalars['DateTime']['output'];
  hasWinnings: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  licensedTerritory: Scalars['String']['output'];
  lotteryId: LotteryId;
  nextDrawDate: Scalars['DateTime']['output'];
  numberOfDraws: Scalars['Int']['output'];
  numberOfPlays: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderedAt: Scalars['DateTime']['output'];
  remainingDraws: Scalars['Int']['output'];
  selectedAddOns: Array<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
  status: PlaySlipOrderStatus;
  subscriptionInfo?: Maybe<SubscriptionInfo>;
  totalWinAmount: Money;
};

export type AddFundsConfigPayload = {
  __typename?: 'AddFundsConfigPayload';
  fees: AddFundsFees;
  limits: AddFundsLimits;
  payment: AddFundsPayment;
  pricePoints: Array<PricePoint>;
  productId?: Maybe<Scalars['String']['output']>;
  withCustomAmount: Scalars['Boolean']['output'];
};

export type AddFundsFees = {
  __typename?: 'AddFundsFees';
  dynamicFee: Scalars['Int']['output'];
  staticFee: Money;
};

export type AddFundsInput = {
  amount: MoneyInput;
  productId: Scalars['String']['input'];
};

export type AddFundsLimits = {
  __typename?: 'AddFundsLimits';
  maxPayInAmount: Money;
  minPayInAmount: Money;
};

export type AddFundsMutationInput = {
  amount: MoneyInput;
  idempotencyKey: Scalars['String']['input'];
  licensedTerritory: Scalars['String']['input'];
  locationData: LocationDataInput;
  paymentData: PaymentDataInput;
  productId?: InputMaybe<Scalars['String']['input']>;
};

export type AddFundsPayment = {
  __typename?: 'AddFundsPayment';
  initial: Array<InitialPaymentInstrument>;
  paymentId: Scalars['String']['output'];
  stored: Array<StoredPaymentInstrument>;
};

export enum AddFundsState {
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Processing = 'PROCESSING'
}

export type AddFundsStatusPayload = {
  __typename?: 'AddFundsStatusPayload';
  id: Scalars['String']['output'];
  isFirstPurchase: Scalars['Boolean']['output'];
  status: AddFundsState;
};

export type AddInstrumentPaymentDataInput = {
  accountId: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  providerData: Array<PaymentDataEntryInput>;
  specificType?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type AddOn = {
  __typename?: 'AddOn';
  /** Must a value for this add-on be selected? */
  mandatory: Scalars['Boolean']['output'];
  /** If this add-on has an additional price, the name must match the name of a price */
  name: Scalars['String']['output'];
  /** Selectable options for this add-on. For example the bet types of the Pick3 lottery */
  options: Array<Scalars['String']['output']>;
  /** Is this add-on configurable per play? */
  perPlay: Scalars['Boolean']['output'];
};

export type AddOnInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type AddOnOutput = {
  __typename?: 'AddOnOutput';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AddOnWithValue = {
  __typename?: 'AddOnWithValue';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AddPaymentInstrumentInput = {
  licensedTerritory: Scalars['String']['input'];
  paymentData: AddInstrumentPaymentDataInput;
};

export type AddPaymentInstrumentPayload = {
  __typename?: 'AddPaymentInstrumentPayload';
  /** false if an existing instrument was updated, true if a new one was created */
  created: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type AlwaysActivePrizeTierCategoryRequirements = PrizeTierCategoryRequirements & {
  __typename?: 'AlwaysActivePrizeTierCategoryRequirements';
  type: PrizeTierCategoryRequirementsPayloadType;
};

export type AnnouncementQueryResponse = {
  __typename?: 'AnnouncementQueryResponse';
  active: Scalars['Boolean']['output'];
  changeDate: Scalars['Instant']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  licensedTerritories: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ApplePayMerchantValidationInput = {
  licensedTerritory: Scalars['String']['input'];
};

export type ApplePayMerchantValidationPayload = {
  __typename?: 'ApplePayMerchantValidationPayload';
  /** Base64 encoded Apple Pay payment session object */
  encodedPaymentSession: Scalars['String']['output'];
};

export enum BadgeType {
  Fire = 'Fire',
  New = 'New',
  Pie = 'Pie',
  PriceTag = 'PriceTag',
  Star = 'Star',
  Text = 'Text'
}

export type BankPayOutInput = {
  accountNumber: Scalars['String']['input'];
  amount: MoneyInput;
  idempotencyKey: Scalars['String']['input'];
  licensedTerritory: Scalars['String']['input'];
  routingNumber: Scalars['String']['input'];
};

export type BonusCodeInfoPayload = {
  __typename?: 'BonusCodeInfoPayload';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /** The date when the promotion expires */
  endDate: Scalars['Instant']['output'];
  title: Scalars['String']['output'];
  /** The type of promotion */
  type: BonusTypeEnum;
  /** Description of the discount that is applied when using the bonus code */
  value: BonusValuePayload;
};

export type BonusCodeRemovalPayload = {
  __typename?: 'BonusCodeRemovalPayload';
  bonusCode: Scalars['String']['output'];
};

export type BonusCodeValidationInput = {
  /** Will be converted to uppercase and dashes will be removed */
  bonusCode: Scalars['String']['input'];
  licensedTerritory: Scalars['String']['input'];
  /** The play slip's lottery ID */
  lotteryId: Scalars['String']['input'];
  /** The price breakdown for play slips */
  priceBreakdown: PlaySlipPriceBreakdownInput;
};

export enum BonusTypeEnum {
  Discount = 'DISCOUNT',
  FreePlay = 'FREE_PLAY'
}

export type BonusValidationResult = {
  __typename?: 'BonusValidationResult';
  /** The discount to apply to the order's charges */
  discount: Money;
  /** True if all conditions could be fulfilled by player actions, e.g. adding more plays */
  fulfillable: Scalars['Boolean']['output'];
  /** True if all conditions are fulfilled */
  fulfilled: Scalars['Boolean']['output'];
  info: BonusCodeInfoPayload;
  /** The minimum purchase amount for the bonus to be valid (or null if no such condition exists) */
  minTotalCharge?: Maybe<Money>;
  /**
   *
   *         A list of error codes to translate. The most important issue will be returned as the first element of the list.
   *
   *         Possible values:
   *           - validation.bonusconditions.customerstatus.new: The promotion only applies to new customers
   *           - validation.bonusconditions.customerstatus.returning: The promotion only applies to returning customers
   *           - validation.bonusconditions.customerstatus.listed: The promotion only applies to a specific set of customer ids
   *           - validation.bonusconditions.lotteries: If the current lottery is not in the list of allowed lotteries for this promotion
   *           - validation.bonusconditions.maxplays: If the play slip contains more than the maximum number of plays allowed for this promotion
   *           - validation.bonusconditions.minplays: If the play slip contains less than the maximum number of plays allowed for this promotion
   *           - validation.bonusconditions.mintotalcharge: If the play slip's gross total price is lower than allowed for this promotion
   *           - validation.bonusconditions.loginrequired: If the user is not logged in but the promotion requires them to be
   *           - validation.bonusconditions.licensedterritory: If the promotion is only valid in another licensed territory
   *           - validation.bonusconditions.scratchcardgames: If the current scratchcard game is not in the list of allowed scratchcard games for this promotion
   *
   */
  unfulfilledConditions: Array<Scalars['String']['output']>;
};

export enum BonusValueEnum {
  Absolute = 'ABSOLUTE',
  Percentage = 'PERCENTAGE'
}

export type BonusValuePayload = {
  __typename?: 'BonusValuePayload';
  amount: Scalars['Long']['output'];
  maxMonetaryValue?: Maybe<Money>;
  type: BonusValueEnum;
};

export type ByAddOnSelected = PrizeTierCategoryRequirements & {
  __typename?: 'ByAddOnSelected';
  addOnName: Scalars['String']['output'];
  /** @deprecated Please use addOnName */
  addonName?: Maybe<Scalars['String']['output']>;
  type: PrizeTierCategoryRequirementsPayloadType;
};

export type ByMultiplierDeselected = PrizeTierCategoryRequirements & {
  __typename?: 'ByMultiplierDeselected';
  addOnName: Scalars['String']['output'];
  type: PrizeTierCategoryRequirementsPayloadType;
};

export type ByMultiplierSelected = PrizeTierCategoryRequirements & {
  __typename?: 'ByMultiplierSelected';
  addOnName: Scalars['String']['output'];
  group: Scalars['DrawnNumbersGroup']['output'];
  /** @deprecated Legacy prefixed name, use 'reference' instead */
  numberReference: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  type: PrizeTierCategoryRequirementsPayloadType;
  value: Scalars['Int']['output'];
};

export type ByMultiplierValueMatched = PrizeTierCategoryRequirements & {
  __typename?: 'ByMultiplierValueMatched';
  addOnName: Scalars['String']['output'];
  type: PrizeTierCategoryRequirementsPayloadType;
  value: Scalars['Int']['output'];
};

export type CampaignBadgePayload = {
  __typename?: 'CampaignBadgePayload';
  bonusCode?: Maybe<Scalars['String']['output']>;
  infoHeadline?: Maybe<Scalars['String']['output']>;
  infoText?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: BadgeType;
};

export type CampaignHeroHighlightBadgePayload = {
  __typename?: 'CampaignHeroHighlightBadgePayload';
  bonusCode?: Maybe<Scalars['String']['output']>;
  color: Scalars['String']['output'];
  infoHeadline?: Maybe<Scalars['String']['output']>;
  infoText?: Maybe<Scalars['String']['output']>;
  placement: HeroHighlightStyle;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CampaignHeroHighlightPayload = {
  __typename?: 'CampaignHeroHighlightPayload';
  badge: CampaignHeroHighlightBadgePayload;
  pattern: HeroHighlightPattern;
};

export type CampaignPayload = CampaignBadgePayload | CampaignHeroHighlightPayload;

export enum CancelReasonType {
  AccountBalanceChanged = 'ACCOUNT_BALANCE_CHANGED',
  InstrumentAlreadyInUse = 'INSTRUMENT_ALREADY_IN_USE',
  PaymentFailed = 'PAYMENT_FAILED',
  ProductPurchaseFailed = 'PRODUCT_PURCHASE_FAILED',
  ProductUnavailable = 'PRODUCT_UNAVAILABLE'
}

export type CancelledOrder = Order & {
  __typename?: 'CancelledOrder';
  bonus?: Maybe<OrderBonus>;
  cancelReasonType: CancelReasonType;
  firstPayIn: Scalars['Boolean']['output'];
  orderId: Scalars['OrderId']['output'];
  playSlip: PlaySlipPayload;
  reference: Scalars['String']['output'];
  status: OrderStatus;
};

/** The new configuration of the player. */
export type ChangeTwoFactorConfigurationPayload = {
  __typename?: 'ChangeTwoFactorConfigurationPayload';
  channels: Array<TwoFactorAuthenticationChannelSettingPayload>;
};

export type ChannelPayload = {
  __typename?: 'ChannelPayload';
  channel: NotificationChannel;
  selected: Scalars['Boolean']['output'];
};

export type Charge = FixedCharge | MultiplyingCharge;

export type ChargeForAddOn = {
  __typename?: 'ChargeForAddOn';
  baseCharge: Money;
  fee: Money;
  name: Scalars['String']['output'];
  total: Money;
};

export type ChargeForAddOnInput = {
  baseCharge: MoneyInput;
  fee: MoneyInput;
  name: Scalars['String']['input'];
  total: MoneyInput;
};

export type ChargeForPlay = {
  __typename?: 'ChargeForPlay';
  addOns: Array<ChargeForAddOn>;
  baseCharge: Money;
  extraInfo?: Maybe<Scalars['String']['output']>;
  fee: Money;
  name: Scalars['String']['output'];
};

export type ChargeForPlayInput = {
  addOns: Array<ChargeForAddOnInput>;
  baseCharge: MoneyInput;
  extraInfo?: InputMaybe<Scalars['String']['input']>;
  fee: MoneyInput;
  name: Scalars['String']['input'];
  total: MoneyInput;
};

export type CheckRoutingNumberPayload = {
  __typename?: 'CheckRoutingNumberPayload';
  bankName?: Maybe<Scalars['String']['output']>;
  isKnown: Scalars['Boolean']['output'];
  routingNumber: Scalars['String']['output'];
};

export enum CheckoutNotification {
  /** Player is located in a neighbour state */
  NeighbourState = 'NEIGHBOUR_STATE'
}

export type CheckoutPayload = {
  __typename?: 'CheckoutPayload';
  accountBalance: Money;
  bonusCode?: Maybe<Scalars['String']['output']>;
  /** Discount applied via bonus codes */
  discount?: Maybe<Money>;
  locationCheckExpires?: Maybe<Scalars['DateTime']['output']>;
  locationProfilingId?: Maybe<Scalars['String']['output']>;
  locationSessionId?: Maybe<Scalars['String']['output']>;
  notification?: Maybe<CheckoutNotification>;
  payment?: Maybe<Payment>;
  product?: Maybe<Product>;
  restrictions?: Maybe<Restrictions>;
  state: CheckoutState;
  /** The total price, including sales tax, with the discount applied */
  totalPriceAfterDiscount?: Maybe<Money>;
};

export enum CheckoutState {
  /** Order is ready to be checked out */
  Ok = 'OK',
  /** The requested product is not (yet) known to the checkout */
  Pending = 'PENDING',
  /** Player is not allowed to perform checkout because of state or geo restrictions */
  Restricted = 'RESTRICTED'
}

/** Optional data to close a player. */
export type ClosePlayerInput = {
  licensedTerritory: Scalars['LicensedTerritory']['input'];
  /**
   * The reason why the player wants to close his account.
   * | The length must be between 1 and 2000 characters: `^.{1,2000}$`
   *
   */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Result of a 'closePlayer' mutation. If the request went successfully, the new player status will be `Closed`. */
export type ClosePlayerPayload = {
  __typename?: 'ClosePlayerPayload';
  /** The new status of the player. */
  status: Status;
};

export type ClosedPlaySlip = PlaySlip & {
  __typename?: 'ClosedPlaySlip';
  firstDrawDate: Scalars['DateTime']['output'];
  hasWinnings: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  licensedTerritory: Scalars['String']['output'];
  lotteryId: LotteryId;
  nextDrawDate: Scalars['DateTime']['output'];
  numberOfDraws: Scalars['Int']['output'];
  numberOfPlays: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderedAt: Scalars['DateTime']['output'];
  selectedAddOns: Array<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
  status: PlaySlipStatus;
  /** @deprecated Please check for (optional) subscriptionInfo instead */
  subscription: Scalars['Boolean']['output'];
  subscriptionInfo?: Maybe<SubscriptionInfo>;
  totalWinAmount: Money;
};

export type ClosedPlaySlipOrder = PlaySlipOrder & {
  __typename?: 'ClosedPlaySlipOrder';
  firstDrawDate: Scalars['DateTime']['output'];
  hasWinnings: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  licensedTerritory: Scalars['String']['output'];
  lotteryId: LotteryId;
  nextDrawDate: Scalars['DateTime']['output'];
  numberOfDraws: Scalars['Int']['output'];
  numberOfPlays: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderedAt: Scalars['DateTime']['output'];
  selectedAddOns: Array<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
  status: PlaySlipOrderStatus;
  subscriptionInfo?: Maybe<SubscriptionInfo>;
  totalWinAmount: Money;
};

export type CreatedOrder = Order & {
  __typename?: 'CreatedOrder';
  bonus?: Maybe<OrderBonus>;
  firstPayIn: Scalars['Boolean']['output'];
  orderId: Scalars['OrderId']['output'];
  playSlip: PlaySlipPayload;
  reference: Scalars['String']['output'];
  status: OrderStatus;
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DeactivateStoredPaymentInstrumentInput = {
  isPayOutInstrument: Scalars['Boolean']['input'];
  paymentInstrumentId: Scalars['String']['input'];
};

export type DefaultTeasersPayload = {
  __typename?: 'DefaultTeasersPayload';
  id: Scalars['String']['output'];
  productType: KnownProductType;
  teasers: Array<TeaserPayload>;
};

export type DrawDate = {
  __typename?: 'DrawDate';
  date?: Maybe<Scalars['Date']['output']>;
  dayOfWeek?: Maybe<DayOfWeek>;
  defaultJackpotValue?: Maybe<Money>;
  time: ZonedTime;
};

export type DrawHistoryByDayPayload = {
  __typename?: 'DrawHistoryByDayPayload';
  /** Number of days */
  count: Scalars['Long']['output'];
  days: Array<DrawsByDayPayload>;
  /** IANA time zone database name of the TZ used to calculate start and end of day. Main TZ of the licensed territory */
  timeZone: Scalars['String']['output'];
};

export type DrawHistoryPayload = {
  __typename?: 'DrawHistoryPayload';
  draws: Array<FinishedDrawPayload>;
  total: Scalars['Int']['output'];
};

export enum DrawInterval {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum DrawLabel {
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
  Friday = 'FRIDAY',
  Midday = 'MIDDAY',
  Monday = 'MONDAY',
  Morning = 'MORNING',
  Night = 'NIGHT',
  None = 'NONE',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DrawNavigationPayload = {
  __typename?: 'DrawNavigationPayload';
  /** The IDs of the draws following the given draw ID, sorted ascending by draw date */
  followingDraws: Array<Scalars['String']['output']>;
  /** The IDs of the draws preceding the given draw ID, sorted descending by draw date */
  previousDraws: Array<Scalars['String']['output']>;
};

export type DrawPayload = {
  __typename?: 'DrawPayload';
  /** Latest time when play slips can be ordered for this draw. */
  closingDate: Scalars['DateTime']['output'];
  /** Minimum jackpot according to the lottery rules. */
  defaultJackpotValue: Money;
  drawDate: Scalars['DateTime']['output'];
  drawnNumbers: Array<DrawnNumbersPayload>;
  hasMultipleDrawsOnDay: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  /** Jackpots for main and additional lotteries. Will only contain the default jackpot for the main lottery when the current jackpot is not entered yet */
  jackpots: Array<Jackpot>;
  label: DrawLabel;
  lotteryConfig: LotteryPayload;
  /** Id of the main lottery. */
  lotteryId: LotteryId;
  prizeCategories: Array<PrizeCategory>;
  state: DrawState;
};

export type DrawResultsFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  lotteries?: InputMaybe<Array<LotteryId>>;
};

export enum DrawState {
  Cancelled = 'CANCELLED',
  Evaluated = 'EVALUATED',
  NumbersEntered = 'NUMBERS_ENTERED',
  Open = 'OPEN',
  Planned = 'PLANNED',
  PrizesEntered = 'PRIZES_ENTERED'
}

export type DrawnNumbersMultipleLines = {
  __typename?: 'DrawnNumbersMultipleLines';
  numbers: Array<Numbers>;
};

export type DrawnNumbersPayload = {
  __typename?: 'DrawnNumbersPayload';
  group: Scalars['DrawnNumbersGroup']['output'];
  /**
   * @deprecated
   *         lotteryId was meant as a grouping but always contained the main lottery.
   *         It is now deprecated and will be removed in the future.
   *
   */
  lotteryId: LotteryId;
  numbers: Array<Numbers>;
  /** For lotteries like GlücksSpirale or ElGordo where the numbers are drawn per rank */
  rank?: Maybe<Scalars['String']['output']>;
  /** For spiel77 / super6 which only have one single number */
  singleNumber: Scalars['Boolean']['output'];
};

export type DrawsByDayPayload = {
  __typename?: 'DrawsByDayPayload';
  /** ISO local date in the form yyyy-MM-dd, local to the 'timeZone' */
  date: Scalars['Date']['output'];
  draws: Array<ReformattedDrawPayload>;
};

export type ExceededLimit = {
  __typename?: 'ExceededLimit';
  available: Money;
  period: LimitPeriod;
  type: LimitType;
  value: Money;
};

export type Fee = FixedFee | MultiplyingFee;

export type FieldInput = {
  name: Scalars['String']['input'];
  selected: Array<Scalars['Int']['input']>;
};

export type FieldOutput = LotteryNumbersSortableByName & {
  __typename?: 'FieldOutput';
  name: Scalars['String']['output'];
  selected: Array<Scalars['Int']['output']>;
};

export type FieldWithMatches = {
  __typename?: 'FieldWithMatches';
  name: Scalars['String']['output'];
  numbers: Array<NumberWithMatch>;
  selected: Array<Scalars['Int']['output']>;
};

export type FinishedDrawPayload = {
  __typename?: 'FinishedDrawPayload';
  addOns: Array<Scalars['String']['output']>;
  drawDate: Scalars['DateTime']['output'];
  drawnNumbers: Array<DrawnNumbersPayload>;
  hasMultipleDrawsOnDay: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  label: DrawLabel;
  lotteryConfig: LotteryPayload;
  /** ID of the main lottery. */
  lotteryId: LotteryId;
  prizeCategories: Array<PrizeCategory>;
};

export type FixedCharge = {
  __typename?: 'FixedCharge';
  id: Scalars['String']['output'];
  perPlay: Scalars['Boolean']['output'];
  type: PriceType;
  value: Money;
};

export type FixedFee = {
  __typename?: 'FixedFee';
  id: Scalars['String']['output'];
  perPlay: Scalars['Boolean']['output'];
  type: PriceType;
  value: Money;
};

export type FreeTicket = PrizePayload & {
  __typename?: 'FreeTicket';
  numberOfFreePlays: Scalars['Int']['output'];
  prize?: Maybe<Money>;
  tier: Scalars['String']['output'];
  tierInfo: PrizeTier;
  type: PrizeTierType;
  winners: Scalars['Int']['output'];
};

export enum GeoCheckStatus {
  IpHostingFacilityDetected = 'IP_HOSTING_FACILITY_DETECTED',
  LocationConfidenceTooLow = 'LOCATION_CONFIDENCE_TOO_LOW',
  LocationConsentTimedOut = 'LOCATION_CONSENT_TIMED_OUT',
  LocationInterceptorDetected = 'LOCATION_INTERCEPTOR_DETECTED',
  LocationIpRoutingIssue = 'LOCATION_IP_ROUTING_ISSUE',
  LocationLocationFail = 'LOCATION_LOCATION_FAIL',
  LocationPrivateBrowsingDetected = 'LOCATION_PRIVATE_BROWSING_DETECTED',
  LocationProfilingEventIssue = 'LOCATION_PROFILING_EVENT_ISSUE',
  LocationSpoofingDetected = 'LOCATION_SPOOFING_DETECTED',
  LocationUnauthorized = 'LOCATION_UNAUTHORIZED',
  LocationWrongIp = 'LOCATION_WRONG_IP',
  NeighbourState = 'NEIGHBOUR_STATE',
  NotInCountry = 'NOT_IN_COUNTRY',
  NotInState = 'NOT_IN_STATE',
  Ok = 'OK',
  ProfileRejected = 'PROFILE_REJECTED',
  ServiceError = 'SERVICE_ERROR',
  ServiceUnavailable = 'SERVICE_UNAVAILABLE',
  VpnOrProxy = 'VPN_OR_PROXY'
}

export enum HeroHighlightPattern {
  Fire = 'Fire',
  Lightning = 'Lightning',
  Money = 'Money',
  Star = 'Star'
}

export enum HeroHighlightStyle {
  BottomM = 'BottomM',
  BottomXl = 'BottomXL',
  TopM = 'TopM',
  TopXl = 'TopXL'
}

export type HypeValidationsPayload = {
  __typename?: 'HypeValidationsPayload';
  massBonusCodesPattern: Scalars['String']['output'];
};

export type ImagePropertiesPayload = {
  __typename?: 'ImagePropertiesPayload';
  blurHash: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type ImagesPayload = {
  __typename?: 'ImagesPayload';
  back: Scalars['String']['output'];
  backCreationDate: Scalars['Instant']['output'];
  backImageProperties: ImagePropertiesPayload;
  linkExpiresAt: Scalars['Instant']['output'];
  scratched: Scalars['String']['output'];
  scratchedCreationDate: Scalars['Instant']['output'];
  scratchedImageProperties: ImagePropertiesPayload;
  unscratched: Scalars['String']['output'];
  unscratchedCreationDate: Scalars['Instant']['output'];
  unscratchedImageProperties: ImagePropertiesPayload;
};

export type InitialPaymentInstrument = {
  __typename?: 'InitialPaymentInstrument';
  /** Unique id for which to register the payment instrument (PXP). */
  accountId: Scalars['String']['output'];
  /** Either CardDeposit or Redirect */
  integrationType: Scalars['String']['output'];
  /** Supported payment methods. For example credit card: ['VISA', 'Mastercard'] */
  methods: Array<Scalars['String']['output']>;
  /** Name of the payment provider */
  provider: Scalars['String']['output'];
  /** In case type == CreditCard this is where to post the Card data to */
  providerUri?: Maybe<Scalars['String']['output']>;
  /** Token used to register a new payment instrument with the provider API */
  token: PaymentToken;
  /** For example CreditCard, PayPal etc. */
  type: Scalars['String']['output'];
  /** For type == Venmo this will contain the venmo-specific profileId */
  venmoProfileId?: Maybe<Scalars['String']['output']>;
};

export type InitialPaymentInstrumentsInput = {
  licensedTerritory: Scalars['String']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type InitialPaymentInstrumentsPayload = {
  __typename?: 'InitialPaymentInstrumentsPayload';
  /** Unique id for which to register the payment instrument (PXP). */
  accountId: Scalars['String']['output'];
  /** Either CardDeposit or Redirect */
  integrationType: Scalars['String']['output'];
  /** Supported payment methods. For example credit card: ['VISA', 'Mastercard'] */
  methods: Array<Scalars['String']['output']>;
  /** Name of the payment provider */
  provider: Scalars['String']['output'];
  /** In case type == CreditCard this is where to post the Card data to */
  providerUri?: Maybe<Scalars['String']['output']>;
  /** Token used to register a new payment instrument with the provider API */
  token: PaymentTokenPayload;
  /** For example CreditCard, PayPal etc. */
  type: Scalars['String']['output'];
  /** For type == Venmo this will contain the venmo-specific profileId */
  venmoProfileId?: Maybe<Scalars['String']['output']>;
};

export type Jackpot = {
  __typename?: 'Jackpot';
  lotteryId: LotteryId;
  value: Money;
};

export type JackpotDefinition = {
  __typename?: 'JackpotDefinition';
  lotteryId: LotteryId;
};

export enum JackpotType {
  Dynamic = 'DYNAMIC',
  Fixed = 'FIXED'
}

export enum KnownProductType {
  Lottery = 'LOTTERY',
  Scratchcard = 'SCRATCHCARD'
}

export type Limit = {
  period: LimitPeriod;
  type: LimitType;
};

export type LimitInput = {
  period: LimitPeriod;
  /** Passing a null value will result in clearing the limit */
  value?: InputMaybe<MoneyInput>;
};

export enum LimitPeriod {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export enum LimitType {
  Deposit = 'DEPOSIT',
  Spending = 'SPENDING'
}

export type Limits = {
  __typename?: 'Limits';
  deposit: Array<Limit>;
  maxDeposit: Array<Limit>;
  maxSpending: Array<Limit>;
  spending: Array<Limit>;
};

export type LimitsInput = {
  limits: Array<LimitInput>;
};

export type LocationDataInput = {
  html5SessionId?: InputMaybe<Scalars['String']['input']>;
  profilingSessionId: Scalars['String']['input'];
  submitterIPAddress?: InputMaybe<Scalars['String']['input']>;
};

export enum LotteryId {
  ArizonaFantasy5 = 'ArizonaFantasy5',
  ArizonaPick3 = 'ArizonaPick3',
  ArizonaThePick = 'ArizonaThePick',
  ArkansasCash3 = 'ArkansasCash3',
  ArkansasCash4 = 'ArkansasCash4',
  ArkansasLotto = 'ArkansasLotto',
  ArkansasNaturalStateJackpot = 'ArkansasNaturalStateJackpot',
  Cash4Life = 'Cash4Life',
  Cash5 = 'Cash5',
  ColoradoCash5 = 'ColoradoCash5',
  ColoradoLotto = 'ColoradoLotto',
  ColoradoPick3 = 'ColoradoPick3',
  EuroMillions = 'EuroMillions',
  FloridaLotto = 'FloridaLotto',
  FloridaPick2 = 'FloridaPick2',
  FloridaPick3 = 'FloridaPick3',
  FloridaPick4 = 'FloridaPick4',
  FloridaPick5 = 'FloridaPick5',
  LaPrimitiva = 'LaPrimitiva',
  LottoAmerica = 'LottoAmerica',
  LottoTexas = 'LottoTexas',
  LuckyForLife = 'LuckyForLife',
  MassachusettsMassCash = 'MassachusettsMassCash',
  MassachusettsMegabucks = 'MassachusettsMegabucks',
  MassachusettsTheNumbersGame = 'MassachusettsTheNumbersGame',
  MegaMillions = 'MegaMillions',
  Melate = 'Melate',
  MinnesotaGopher5 = 'MinnesotaGopher5',
  MinnesotaNorth5 = 'MinnesotaNorth5',
  MinnesotaPick3 = 'MinnesotaPick3',
  NebraskaMyDay = 'NebraskaMyDay',
  NebraskaPick3 = 'NebraskaPick3',
  NebraskaPick5 = 'NebraskaPick5',
  NewYorkLotto = 'NewYorkLotto',
  NewYorkNumbers = 'NewYorkNumbers',
  NewYorkPick10 = 'NewYorkPick10',
  NewYorkTake5 = 'NewYorkTake5',
  NewYorkWin4 = 'NewYorkWin4',
  OhioClassicLotto = 'OhioClassicLotto',
  OhioPick3 = 'OhioPick3',
  OhioPick4 = 'OhioPick4',
  OhioPick5 = 'OhioPick5',
  OhioRollingCash5 = 'OhioRollingCash5',
  OregonLuckyLines = 'OregonLuckyLines',
  OregonMegabucks = 'OregonMegabucks',
  OregonPick4 = 'OregonPick4',
  Pick3 = 'Pick3',
  Pick4 = 'Pick4',
  Pick6 = 'Pick6',
  PowerBall = 'PowerBall',
  PuertoRicoPega3 = 'PuertoRicoPega3',
  PuertoRicoPega4 = 'PuertoRicoPega4',
  TexasAllOrNothing = 'TexasAllOrNothing',
  TexasCashFive = 'TexasCashFive',
  TexasDaily4 = 'TexasDaily4',
  TexasPick3 = 'TexasPick3',
  TexasTwoStep = 'TexasTwoStep',
  TristateMegabucks = 'TristateMegabucks',
  TristatePick3 = 'TristatePick3',
  TristatePick4 = 'TristatePick4'
}

export type LotteryNumbersSortableByName = {
  name: Scalars['String']['output'];
};

export type LotteryPayload = {
  __typename?: 'LotteryPayload';
  active: Scalars['Boolean']['output'];
  /** @deprecated Use currentConfig */
  config: Array<VersionedConfig>;
  currentConfig: VersionedConfig;
  id: LotteryId;
  licensedTerritory: Scalars['String']['output'];
  priceList: PriceListPayload;
  properties: Array<LotteryProperty>;
  /** IANA time zone database id */
  timeZone: Scalars['String']['output'];
};

export type LotteryProduct = {
  __typename?: 'LotteryProduct';
  /** @deprecated Use `productName` - which contains the actual name instead of a key - instead */
  name: Scalars['String']['output'];
  numberOfDraws: Scalars['Int']['output'];
  numberOfPlays: Scalars['Int']['output'];
  playSlipId: Scalars['String']['output'];
  price: Money;
  priceBreakdown: PriceBreakdown;
  productName: Scalars['String']['output'];
  subscription: Scalars['Boolean']['output'];
  subscriptionOptions?: Maybe<SubscriptionOptions>;
};

export enum LotteryProperty {
  Additional = 'ADDITIONAL',
  FixedJackpot = 'FIXED_JACKPOT',
  PayoutOption = 'PAYOUT_OPTION'
}

export type LotteryResultsMultipleLines = {
  __typename?: 'LotteryResultsMultipleLines';
  countOfPlays: Scalars['Int']['output'];
  /** Drawn numbers for the lottery 'name', will be 'null' until numbers are saved at the draw */
  drawnNumbers?: Maybe<DrawnNumbersMultipleLines>;
  /** Name of the DrawnNumbersGroup, either 'DEFAULT or 'DOUBLE_PLAY', 'GREENBALL' etc. */
  group: Scalars['String']['output'];
  /**
   *
   *             Returns a paginated list of plays for the play slip order.
   *             Valid values for the limit are 1 to 50.
   *             Valid values for offset are at least 0.
   *             The default values are 0 for offset and 10 for limit.
   *
   *             To load only plays for a specific draw date and number group, provide the 'drawDateOfPlay' and 'groupOfPlays' parameters.
   *
   */
  plays: Array<PlaysMultipleLines>;
};


export type LotteryResultsMultipleLinesPlaysArgs = {
  drawDateOfPlays?: InputMaybe<Scalars['DateTime']['input']>;
  groupOfPlays?: InputMaybe<Scalars['DrawnNumbersGroup']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LotterySpecificPrizeTierCategoryRequirements = PrizeTierCategoryRequirements & {
  __typename?: 'LotterySpecificPrizeTierCategoryRequirements';
  type: PrizeTierCategoryRequirementsPayloadType;
};

export type LotterySpecificPrizeTierRequirements = PrizeTierRequirements & {
  __typename?: 'LotterySpecificPrizeTierRequirements';
  type: PrizeTierRequirementsPayloadType;
};

export type LotteryTeaserPayload = TeaserPayload & {
  __typename?: 'LotteryTeaserPayload';
  campaign?: Maybe<CampaignPayload>;
  closingDate: Scalars['DateTime']['output'];
  comingSoon: Scalars['Boolean']['output'];
  drawDate: Scalars['DateTime']['output'];
  id: LotteryId;
  jackpotSize: Money;
  jackpotType: JackpotType;
  lotteryType: LotteryType;
  name: Scalars['String']['output'];
  quickPick?: Maybe<QuickPickConfiguration>;
};

/**
 *
 *     Classifies a lottery into two distinct types:
 *     - PICK_LOTTERY
 *       This type lets players choose n numbers with repetition. Often there are modifiers to increase the winning chance (e.g.
 *       bet type, stake, ...).
 *     - NUMBER_LOTTERY
 *       This type lets players choose n over m numbers without repetition, possibly having an additional special number as well. In contrast
 *       to a pick lottery, a number lottery has different prize tiers depending on the amount of correctly selected numbers.
 *
 */
export enum LotteryType {
  NumberLottery = 'NUMBER_LOTTERY',
  PickLottery = 'PICK_LOTTERY'
}

export type LuckyLines = PrizeTierRequirements & {
  __typename?: 'LuckyLines';
  matchingLines: Array<Scalars['Int']['output']>;
  type: PrizeTierRequirementsPayloadType;
};

export enum MarketingChannel {
  Email = 'EMAIL',
  PushNotification = 'PUSH_NOTIFICATION',
  Sms = 'SMS'
}

export type MarketingChannelPreferenceMutationInput = {
  activated: Scalars['Boolean']['input'];
  channel: MarketingChannel;
};

export type MarketingChannelPreferencesPayload = {
  __typename?: 'MarketingChannelPreferencesPayload';
  activated: Scalars['Boolean']['output'];
  channel: MarketingChannel;
  verified: Scalars['Boolean']['output'];
};

export type MarketingPreferencesPayload = {
  __typename?: 'MarketingPreferencesPayload';
  channels: Array<MarketingChannelPreferencesPayload>;
};

export type MaxLimit = Limit & {
  __typename?: 'MaxLimit';
  period: LimitPeriod;
  type: LimitType;
  value: Money;
};

export type Money = {
  __typename?: 'Money';
  currency: Scalars['String']['output'];
  value: Scalars['Long']['output'];
};

export type MoneyBackInput = {
  code: Scalars['String']['input'];
};

export type MoneyBackPayload = {
  __typename?: 'MoneyBackPayload';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  price: Money;
  productId: Scalars['String']['output'];
  status: MoneyBackStatus;
};

export enum MoneyBackStatus {
  Created = 'CREATED',
  Expired = 'EXPIRED',
  Redeemed = 'REDEEMED'
}

export type MoneyInput = {
  currency: Scalars['String']['input'];
  value: Scalars['Long']['input'];
};

export type MultiplyingCharge = {
  __typename?: 'MultiplyingCharge';
  id: Scalars['String']['output'];
  multiplier: Scalars['Int']['output'];
  perPlay: Scalars['Boolean']['output'];
  type: PriceType;
};

export type MultiplyingFee = {
  __typename?: 'MultiplyingFee';
  id: Scalars['String']['output'];
  multiplier: Scalars['Int']['output'];
  perPlay: Scalars['Boolean']['output'];
  type: PriceType;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   *
   * Adds funds to the player's account.
   * Possible errors:
   * - internal.error In case of a server error.
   * - authentication.noauthheader If the player is not logged in.
   * - validation.addfunds.fundinglimitexceeded If none of the price points is lower or equal to the player's funding limit.
   * - validation.addfunds.amounttoohigh Amount > maximum allowed add funds limit
   * - validation.addfunds.amounttoolow Amount < minimum allowed add funds limit
   * - validation.addfunds.amountnopricepoint The given amount is not included in the price points
   * - validation.addfunds.invalidpaymentid The given payment ID has an invalid format or the payment can not be found
   * - validation.addfunds.alreadyprocessed The funding process for the given payment ID is already started
   * - validation.addfunds.invalidpaymentprovider The given payment provider does not support funding
   * - validation.addfunds.invalidpaymenttype The given payment type is invalid
   * - validation.addfunds.invalidpaymentmethod The given payment method is invalid
   * - validation.addfunds.cvvrequired The given payment method requires re-entering the CVV for stored cards, but none was provided
   * - location.wrongcountry.error If the user is located in a country other than the expected one
   * - location.wrongstate.error If the user is located in the expected country but a different state than expected
   * - location.confidencetoolow.error If the confidence that the user is in the expected location is too low
   * - location.consenttimedout.error If the location data sent to the location provider are too old
   * - location.notavailable.error If the location could not be determined
   * - location.spoofingdetected.error If the location check detected a spoofing attempt
   * - location.wrongiplocation.error If the IP is not located in the allowed country or state
   * - location.unauthorizedforlocation.error If the location check has not been authorized by the user
   * - location.profilingeventissue.error If the location check encountered a profiling event issue
   * - location.interceptordetected.error If the location check detected an interceptor like VPN or TOR
   * - location.privatebrowsingdetected.error If the location check detected that private browsing is active
   * - location.iproutingissue.error If the location check ran into an IP routing issue
   * - location.locationfail.error If the device could not be located by the specified location method
   * - location.profilerejected.error If the device profile analysis showed a fraud risk
   * - location.internal.error If an unexpected error occurred while determining the user's location
   *
   */
  addFunds: AddFundsStatusPayload;
  /**
   *
   * Creates a new payment instrument or updates an existing one. Currently only credit cards are supported.
   * Possible errors:
   * - paymenttype.invalid if the paymentData's type is invalid (i.E. currently anything other than 'CreditCard')
   * - cardtype.invalid if the paymentData's 'cardType' does not exist or is not a valid payment method
   * - provider.active if the paymentData's 'provider' is not enabled for the user's licensed territory
   * - provider.invalid if the paymentData's 'provider' is not a recognized provider
   * - instrument.registration.failed if the registration of the payment instrument failed
   * - paymentdata.invalid if required values for the requested provider are missing from the payment data
   */
  addPaymentInstrument: AddPaymentInstrumentPayload;
  /**
   *
   *             Lets the player apply a bonus code on the checkout page.
   *             The same validations as in the BonusCodeValidationQuery apply, but this mutation is only accessible for logged in customers.
   *             If the validation of the bonus code succeeds, the checkout is messaged, so that it can update the discounted price accordingly.
   *             Any already applied bonus code will be removed.
   *             If the bonus code validation fails, one of the following errors is possible:
   *             - validation.bonusconditions.notfulfilled
   *               If the bonus code can be applied, but some of the bonus' conditions have not been fulfilled yet.
   *             - validation.bonusconditions.unfulfillable
   *               If the bonus code cannot be applied (e.g. the promotion belonging to the bonus code has expired).
   *
   *             If product ID cannot be resolved to a product, then the following error will be returned:
   *             - product.unknown
   *
   */
  applyBonusCode: BonusValidationResult;
  /**
   *
   *     Attempts to buy the given product (e.g. play slip).
   *     Possible errors:
   *     - account.notfound If no account for the current player was found
   *     - product.notfound If the given product was not found
   *     - player.notfound If the current player is not known
   *     - insufficientfunds.error If the current player's account has insufficient funds to buy the product
   *     - limit.exceeded.error If there are limits on the current player's account that would be exceeded by the purchase
   *     - order.update.error If an error occurred while updating the order
   *     - product.update.error If an error occurred while updating the product
   *     - player.status.error If the current player's status (e.g. SelfExcluded) prevents them from purchasing
   *     - player.notverified.error If the current player hasn't been verified
   *     - server.error If an unexpected error occurred while processing the purchase
   *     - stake.error If an error occurred while processing the stake transaction
   *     - location.wrongcountry.error If the user is located in a country other than the expected one
   *     - location.wrongstate.error If the user is located in the expected country but a different state than expected
   *     - location.confidencetoolow.error If the confidence that the user is in the expected location is too low
   *     - location.consenttimedout.error If the location data sent to the location provider are too old
   *     - location.notavailable.error If the location could not be determined
   *     - location.spoofingdetected.error If the location check detected a spoofing attempt
   *     - location.wrongiplocation.error If the IP is not located in the allowed country or state
   *     - location.unauthorizedforlocation.error If the location check has not been authorized by the user
   *     - location.profilingeventissue.error If the location check encountered a profiling event issue
   *     - location.interceptordetected.error If the location check detected an interceptor like VPN or TOR
   *     - location.privatebrowsingdetected.error If the location check detected that private browsing is active
   *     - location.iproutingissue.error If the location check ran into an IP routing issue
   *     - location.locationfail.error If the device could not be located by the specified location method
   *     - location.profilerejected.error If the device profile analysis showed a fraud risk
   *     - location.internal.error If an unexpected error occurred while determining the user's location
   *
   */
  buySingleProductWithBalance: Order;
  /**
   *
   *     Attempts to buy the given product (e.g. play slip).
   *     Possible errors:
   *     - account.notfound If no account for the current player was found
   *     - product.notfound If the given product was not found
   *     - player.notfound If the current player is not known
   *     - insufficientfunds.error If the current player's account has insufficient funds to buy the product
   *     - limit.exceeded.error If there are limits on the current player's account that would be exceeded by the purchase
   *     - order.update.error If an error occurred while updating the order
   *     - product.update.error If an error occurred while updating the product
   *     - player.status.error If the current player's status (e.g. SelfExcluded) prevents them from purchasing
   *     - player.notverified.error If the current player hasn't been verified
   *     - server.error If an unexpected error occurred while processing the purchase
   *     - stake.error If an error occurred while processing the stake transaction
   *     - location.wrongcountry.error If the user is located in a country other than the expected one
   *     - location.wrongstate.error If the user is located in the expected country but a different state than expected
   *     - location.confidencetoolow.error If the confidence that the user is in the expected location is too low
   *     - location.consenttimedout.error If the location data sent to the location provider are too old
   *     - location.notavailable.error If the location could not be determined
   *     - location.spoofingdetected.error If the location check detected a spoofing attempt
   *     - location.wrongiplocation.error If the IP is not located in the allowed country or state
   *     - location.unauthorizedforlocation.error If the location check has not been authorized by the user
   *     - location.profilingeventissue.error If the location check encountered a profiling event issue
   *     - location.interceptordetected.error If the location check detected an interceptor like VPN or TOR
   *     - location.privatebrowsingdetected.error If the location check detected that private browsing is active
   *     - location.iproutingissue.error If the location check ran into an IP routing issue
   *     - location.locationfail.error If the device could not be located by the specified location method
   *     - location.profilerejected.error If the device profile analysis showed a fraud risk
   *     - location.internal.error If an unexpected error occurred while determining the user's location
   *
   */
  buySingleProductWithPxpCreditCard: Order;
  /**
   *
   *     Attempts to buy the given product (e.g. play slip).
   *     Possible errors:
   *     - account.notfound If no account for the current player was found
   *     - product.notfound If the given product was not found
   *     - player.notfound If the current player is not known
   *     - insufficientfunds.error If the current player's account has insufficient funds to buy the product
   *     - limit.exceeded.error If there are limits on the current player's account that would be exceeded by the purchase
   *     - order.update.error If an error occurred while updating the order
   *     - product.update.error If an error occurred while updating the product
   *     - player.status.error If the current player's status (e.g. SelfExcluded) prevents them from purchasing
   *     - player.notverified.error If the current player hasn't been verified
   *     - server.error If an unexpected error occurred while processing the purchase
   *     - stake.error If an error occurred while processing the stake transaction
   *     - location.wrongcountry.error If the user is located in a country other than the expected one
   *     - location.wrongstate.error If the user is located in the expected country but a different state than expected
   *     - location.confidencetoolow.error If the confidence that the user is in the expected location is too low
   *     - location.consenttimedout.error If the location data sent to the location provider are too old
   *     - location.notavailable.error If the location could not be determined
   *     - location.spoofingdetected.error If the location check detected a spoofing attempt
   *     - location.wrongiplocation.error If the IP is not located in the allowed country or state
   *     - location.unauthorizedforlocation.error If the location check has not been authorized by the user
   *     - location.profilingeventissue.error If the location check encountered a profiling event issue
   *     - location.interceptordetected.error If the location check detected an interceptor like VPN or TOR
   *     - location.privatebrowsingdetected.error If the location check detected that private browsing is active
   *     - location.iproutingissue.error If the location check ran into an IP routing issue
   *     - location.locationfail.error If the device could not be located by the specified location method
   *     - location.profilerejected.error If the device profile analysis showed a fraud risk
   *     - location.internal.error If an unexpected error occurred while determining the user's location
   *
   */
  buySingleProductWithTopUp: Order;
  /** Cancels a subscription and returns the resulting subscription code. */
  cancelSubscription: SubscriptionInfo;
  changeLimitValue: Array<Limit>;
  /**
   *
   * Change a logged-in players two factor configuration.
   *
   */
  changeTwoFactorConfiguration: ChangeTwoFactorConfigurationPayload;
  /** Closes a player's account */
  closePlayer: ClosePlayerPayload;
  /**
   *
   *         Deactivates a given payIn or payOut instrument.
   *         Possible errors:
   *         - paymentinstrument.notfound If the specified payIn/payOut instrument was not found for the player
   *
   */
  deactivateStoredPaymentInstrument: TogglePaymentInstrument;
  /**
   *
   * Creates a pay out bank account and a pay out of the given amount.
   * Possible errors:
   * - validation.payout.minimum If the pay out amount is lower than the minimum value.
   * - validation.payout.notEnoughPayableBalance If the customer account does not have enough payable balance
   * - validation.payout.invalidinstrument If the customer has an active PayPal instrument, it must be used instead
   *
   */
  payOutToBankAccount: PayOutPayload;
  /**
   *
   * Creates a pay out of the given amount and the saved pay out account referenced by the payoutAccountId.
   * Possible errors:
   * - notfound.payout.account If there is no pay out account for the given payoutAccountId
   * - validation.payout.minimum If the pay out amount is lower than the minimum value.
   * - validation.payout.notEnoughPayableBalance If the customer account does not have enough payable balance
   * - validation.payout.invalidinstrument If the customer tries to pay out to a saved bank account while another payout instrument is active
   *
   */
  payOutToSavedAccount: PayOutPayload;
  /**
   *
   *             Removes an applied bonus code from a product for a logged in player.
   *             If the bonus code does not exist, the following error is returned:
   *             - validation.bonuscode.unknown
   *
   *             If an invalid product ID is supplied, the mutation will return:
   *             - product.unknown
   *
   *             If for any reason the message cannot be send to the checkout, this error will be returned:
   *             - internal.error
   *
   */
  removeBonusCode: BonusCodeRemovalPayload;
  /** Stores a new play slip from the one defined with the 'playSlipId' parameter. */
  replayPlaySlip: PlaySlipStored;
  /** Requests money back */
  requestMoneyBack: MoneyBackPayload;
  /** Request a password reset token for the player with the given email address. */
  requestPasswordReset: RequestPasswordResetPayload;
  /** Requests a new phone verification code */
  requestVerificationCode: ResendCodePayload;
  /**
   *
   *             Attempts to reserve a quantity of scratchcards for a game.
   *
   *             Possible error codes:
   *             - validation.licensedterritory.invalid - if the licensed territory has an invalid format
   *             - validation.licensedterritory.unknown - if the licensed territory is not configured
   *             - validation.value.notinrange - if the requested quantity falls outside the allowed range
   *             - validation.slug.invalid - if the given game slug has an invalid format
   *             - validation.game.notfound - if the game could not be found
   *             - validation.player.notfound - if the player could not be found
   *             - validation.player.invalidstatus - if the player is not verified
   *             - validation.player.minimumage - if the player is below the licensed territory's minimum age
   *             - validation.spendinglimit.exceeded - if the player's limit would be exceeded by reserving
   *             - unavailable.game.soldout - if all scratch cards for the game have been sold
   *             - unavailable.game.reserved - if all scratch cards for the game have been either sold or reserved (reservations may expire)
   *             - unavailable.game.limitedstock - if there are fewer scratch cards available than requested (reservations may expire)
   *             - error.internalserver - if a database error occurs
   *
   */
  reserveScratchcards: ScratchcardReservation;
  /**
   *
   *             Reveals ("scratches") all scratchcards for an order.
   *
   *             The order must belong to the logged in player. The mutation returns the revealed order.
   *
   *             Possible error codes:
   *             - validation.game.notfound - if the game could not be found
   *             - validation.scratchcardorder.notfound - if the order could not be found or does not belong to the logged in player
   *             - validation.scratchcardstate.wrong - if the order does not have the correct state (must be SCRATCHED or REVEALED)
   *             - notfound.scratchcard.id - if one of the scratchcards of the order could not be found
   *             - error.internalServer - if a database error occurs
   *
   */
  revealOrder: ScratchcardOrderDetail;
  /**
   *
   *             Reveals ("scratches") a single scratchcard.
   *
   *             The card must belong to the logged in player. The mutation returns the winnings of the scratchcard.
   *
   *             Possible error codes:
   *             - validation.game.notfound - if the game could not be found
   *             - validation.scratchcard.notfound - if the given scratchcard could not be found or does not belong to the logged in player
   *             - validation.scratchcardstate.wrong - if the scratchcard does not have the correct state (must be SCRATCHED or REVEALED)
   *             - error.internalServer - if a database error occurs
   *
   */
  revealScratchcard: WinningsPayload;
  /** Set a player's account to self-exclude */
  selfExclusion: SelfExclusionPayload;
  /** sets the marketing channel preferences for the player. */
  setMarketingChannelPreferences: MarketingChannelPreferencesPayload;
  setPreferences: Array<PreferencePayload>;
  setScanVerifyUploadStatus: VerificationPayload;
  /** Stores a play slip and returns the resulting play slip order ID. */
  storePlaySlip: PlaySlipStored;
  unsubscribeMarketingEmails: UnsubscribeMarketingPayload;
  uploadIdentityDocument: UploadIdentityDocumentPayload;
  /** Verifies a user’s email address */
  verifyEmail: VerifyEmailPayload;
  /** Verifies a phone number if given a valid phone verification code */
  verifyPhone: VerifyPhonePayload;
};


export type MutationAddFundsArgs = {
  input: AddFundsMutationInput;
};


export type MutationAddPaymentInstrumentArgs = {
  input: AddPaymentInstrumentInput;
};


export type MutationApplyBonusCodeArgs = {
  bonusCode: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationBuySingleProductWithBalanceArgs = {
  licensedTerritory: Scalars['String']['input'];
  locationProfilingId: Scalars['String']['input'];
  locationSessionId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ProductId']['input'];
  submitterIPAddress?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBuySingleProductWithPxpCreditCardArgs = {
  licensedTerritory: Scalars['String']['input'];
  locationProfilingId: Scalars['String']['input'];
  locationSessionId?: InputMaybe<Scalars['String']['input']>;
  paymentData: PxpCreditCardInput;
  productId: Scalars['ProductId']['input'];
  submitterIPAddress?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBuySingleProductWithTopUpArgs = {
  licensedTerritory: Scalars['String']['input'];
  locationProfilingId: Scalars['String']['input'];
  locationSessionId?: InputMaybe<Scalars['String']['input']>;
  paymentData: PaymentDataInput;
  productId: Scalars['ProductId']['input'];
  submitterIPAddress?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelSubscriptionArgs = {
  input: SubscriptionInput;
};


export type MutationChangeLimitValueArgs = {
  type: LimitType;
  value: LimitsInput;
};


export type MutationChangeTwoFactorConfigurationArgs = {
  input: TwoFactorAuthenticationChannelSettingPayloadInput;
};


export type MutationClosePlayerArgs = {
  input: ClosePlayerInput;
};


export type MutationDeactivateStoredPaymentInstrumentArgs = {
  input: DeactivateStoredPaymentInstrumentInput;
};


export type MutationPayOutToBankAccountArgs = {
  input: BankPayOutInput;
};


export type MutationPayOutToSavedAccountArgs = {
  input: SavedPayOutInput;
};


export type MutationRemoveBonusCodeArgs = {
  bonusCode: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationReplayPlaySlipArgs = {
  licensedTerritory: Scalars['String']['input'];
  playSlipOrderId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestMoneyBackArgs = {
  input: MoneyBackInput;
};


export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};


export type MutationRequestVerificationCodeArgs = {
  input: ResendCodeMutationInput;
};


export type MutationReserveScratchcardsArgs = {
  input: ReserveScratchcardsInput;
};


export type MutationRevealOrderArgs = {
  input: RevealOrderInput;
};


export type MutationRevealScratchcardArgs = {
  input: RevealScratchcardInput;
};


export type MutationSelfExclusionArgs = {
  input: SelfExclusionInput;
};


export type MutationSetMarketingChannelPreferencesArgs = {
  input: MarketingChannelPreferenceMutationInput;
};


export type MutationSetPreferencesArgs = {
  input: PreferencesInput;
};


export type MutationSetScanVerifyUploadStatusArgs = {
  input: SetScanVerifyUploadStatusInput;
};


export type MutationStorePlaySlipArgs = {
  input: PlaySlipInput;
};


export type MutationUnsubscribeMarketingEmailsArgs = {
  input: UnsubscribeMarketingInput;
};


export type MutationUploadIdentityDocumentArgs = {
  input: UploadIdentityDocumentInput;
};


export type MutationVerifyEmailArgs = {
  input: VerifyEmailInput;
};


export type MutationVerifyPhoneArgs = {
  input: VerifyPhoneInput;
};

export enum Notification {
  CreditNoteGranted = 'CREDIT_NOTE_GRANTED',
  DormancyReminder = 'DORMANCY_REMINDER',
  EmailChanged = 'EMAIL_CHANGED',
  FundsAdded = 'FUNDS_ADDED',
  Login = 'LOGIN',
  LoginCode = 'LOGIN_CODE',
  MoneyBackCreated = 'MONEY_BACK_CREATED',
  MoneyBackReminder = 'MONEY_BACK_REMINDER',
  OrderConfirmation = 'ORDER_CONFIRMATION',
  PasswordReset = 'PASSWORD_RESET',
  PasswordResetRequested = 'PASSWORD_RESET_REQUESTED',
  PayoutConfirmation = 'PAYOUT_CONFIRMATION',
  PayoutRejected = 'PAYOUT_REJECTED',
  PlayerAccountClosed = 'PLAYER_ACCOUNT_CLOSED',
  PlayerCoolOff = 'PLAYER_COOL_OFF',
  PlayerLoginBlocked = 'PLAYER_LOGIN_BLOCKED',
  PlayerManuallyAgeVerified = 'PLAYER_MANUALLY_AGE_VERIFIED',
  PlayerSelfExcluded = 'PLAYER_SELF_EXCLUDED',
  PlayerSuspended = 'PLAYER_SUSPENDED',
  PlayerSuspendedAfterSelfExclusion = 'PLAYER_SUSPENDED_AFTER_SELF_EXCLUSION',
  ProductCancelled = 'PRODUCT_CANCELLED',
  PurchaseConfirmation = 'PURCHASE_CONFIRMATION',
  ScratchcardBatchCancelled = 'SCRATCHCARD_BATCH_CANCELLED',
  ScratchcardOrdered = 'SCRATCHCARD_ORDERED',
  ScratchcardOrderRevealed = 'SCRATCHCARD_ORDER_REVEALED',
  ScratchcardReady = 'SCRATCHCARD_READY',
  ScratchcardWin = 'SCRATCHCARD_WIN',
  SubscriptionCancellation = 'SUBSCRIPTION_CANCELLATION',
  Welcome = 'WELCOME',
  WinningNotification = 'WINNING_NOTIFICATION'
}

export enum NotificationChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type NumberLottery = PrizeTierRequirements & {
  __typename?: 'NumberLottery';
  numberRequirements: Array<NumberRequirement>;
  type: PrizeTierRequirementsPayloadType;
};

export type NumberRequirement = {
  __typename?: 'NumberRequirement';
  amountOfCorrectNumbers: Scalars['Int']['output'];
  numbersReference: Scalars['String']['output'];
};

export type NumberWithMatch = {
  __typename?: 'NumberWithMatch';
  matching: Scalars['Boolean']['output'];
  value: Scalars['Int']['output'];
};

export type Numbers = LotteryNumbersSortableByName & {
  __typename?: 'Numbers';
  /** When set, the value(s) already set in the `Numbers` block with the name stored in this field. They just have additional properties (like the Bullseye number for NJ Cash5, where this field would refer to 'BASE') */
  modifies?: Maybe<Scalars['String']['output']>;
  /** Matches lottery numbers name like 'BASE' or 'EXTRA' */
  name: Scalars['String']['output'];
  values: Array<Scalars['Int']['output']>;
};

export type NumbersConfig = {
  __typename?: 'NumbersConfig';
  ignoredForAddOns: Array<AddOnWithValue>;
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  selectableMax: Scalars['Int']['output'];
  selectableMin: Scalars['Int']['output'];
};

export type Order = {
  /** Optional bonus applied to this order */
  bonus?: Maybe<OrderBonus>;
  /** Flag that indicates whether this order is the first pay in */
  firstPayIn: Scalars['Boolean']['output'];
  /** Order id for this player */
  orderId: Scalars['OrderId']['output'];
  /** Federated play slip */
  playSlip: PlaySlipPayload;
  /** Unique order reference */
  reference: Scalars['String']['output'];
  status: OrderStatus;
};

export type OrderBonus = {
  __typename?: 'OrderBonus';
  /** Bonus code applied to this order */
  bonusCode: Scalars['String']['output'];
  /** Discount amount granted for this order */
  discount: Money;
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Paid = 'PAID',
  PartiallyCancelled = 'PARTIALLY_CANCELLED',
  PaymentDone = 'PAYMENT_DONE',
  Processing = 'PROCESSING'
}

export type OrderedTypePayload = {
  __typename?: 'OrderedTypePayload';
  lottery: Scalars['Boolean']['output'];
  scratchcard: Scalars['Boolean']['output'];
  subscription: Scalars['Boolean']['output'];
};

export type PaidOrder = Order & {
  __typename?: 'PaidOrder';
  bonus?: Maybe<OrderBonus>;
  firstPayIn: Scalars['Boolean']['output'];
  orderId: Scalars['OrderId']['output'];
  playSlip: PlaySlipPayload;
  reference: Scalars['String']['output'];
  status: OrderStatus;
};

export type PayOutAccount = {
  holderName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: PayOutAccountType;
};

export type PayOutAccountBank = PayOutAccount & {
  __typename?: 'PayOutAccountBank';
  /** Masked account number. Only the last 4 digits are displayed. */
  accountNumber: Scalars['String']['output'];
  holderName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Masked routing number. Only the last 4 digits are displayed. */
  routingNumber: Scalars['String']['output'];
  type: PayOutAccountType;
};

export type PayOutAccountPayPal = PayOutAccount & {
  __typename?: 'PayOutAccountPayPal';
  holderName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** The payer's PayPal email address. */
  payPalPayerEmail: Scalars['String']['output'];
  type: PayOutAccountType;
};

export enum PayOutAccountType {
  Bank = 'Bank',
  PayPal = 'PayPal'
}

export type PayOutOptions = {
  __typename?: 'PayOutOptions';
  /** Saved accounts for pay out. Use the id to call payOutToSavedAccount. */
  accounts: Array<PayOutAccount>;
  /** Given name + family name of the player used as account holder for payment accounts */
  holderName: Scalars['String']['output'];
  /** The maximum payable amount. */
  maxPayableBalance: Money;
  /** The lowest possible amount to pay out. */
  minPayableBalance: Money;
  restrictions?: Maybe<PaymentRestrictions>;
};

export type PayOutPayload = {
  __typename?: 'PayOutPayload';
  amount: Money;
  id: Scalars['String']['output'];
  state: PayOutState;
};

export enum PayOutState {
  Created = 'CREATED',
  Finished = 'FINISHED',
  Invalid = 'INVALID',
  Performed = 'PERFORMED',
  Rejected = 'REJECTED'
}

export type PayWithBalance = Payment & {
  __typename?: 'PayWithBalance';
  accountBalance: Money;
  payWithBalance: Scalars['Boolean']['output'];
  topUpAmount: Money;
  totalPrice: Money;
};

export type PayWithTopUp = Payment & {
  __typename?: 'PayWithTopUp';
  accountBalance: Money;
  initial: Array<InitialPaymentInstrument>;
  payWithBalance: Scalars['Boolean']['output'];
  paymentId: Scalars['String']['output'];
  stored: Array<StoredPaymentInstrument>;
  topUpAmount: Money;
  totalPrice: Money;
};

export type Payment = {
  accountBalance: Money;
  payWithBalance: Scalars['Boolean']['output'];
  topUpAmount: Money;
  totalPrice: Money;
};

export type PaymentDataEntryInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type PaymentDataInput = {
  accountId: Scalars['String']['input'];
  paymentId: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  providerData: Array<PaymentDataEntryInput>;
  /** For example Visa, MasterCard etc. */
  specificType?: InputMaybe<Scalars['String']['input']>;
  stored: Scalars['Boolean']['input'];
  /** For example CreditCard, PayPal etc. */
  type: Scalars['String']['input'];
};

export enum PaymentInstrumentType {
  CreditCard = 'CreditCard',
  PayPal = 'PayPal',
  Venmo = 'Venmo'
}

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  allowsSubscriptionPurchase: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PaymentRestrictions = {
  __typename?: 'PaymentRestrictions';
  playerCheck: PlayerRestriction;
};

export type PaymentToken = {
  __typename?: 'PaymentToken';
  expires: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type PaymentTokenPayload = {
  __typename?: 'PaymentTokenPayload';
  expires: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

/** How often a prize is paid out */
export enum PayoutInterval {
  Daily = 'DAILY',
  Once = 'ONCE',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type PendingPlaySlip = PlaySlip & {
  __typename?: 'PendingPlaySlip';
  firstDrawDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  licensedTerritory: Scalars['String']['output'];
  lotteryId: LotteryId;
  nextDrawDate: Scalars['DateTime']['output'];
  numberOfDraws: Scalars['Int']['output'];
  numberOfPlays: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderedAt: Scalars['DateTime']['output'];
  selectedAddOns: Array<Scalars['String']['output']>;
  status: PlaySlipStatus;
  /** @deprecated Please check for (optional) subscriptionInfo instead */
  subscription: Scalars['Boolean']['output'];
  subscriptionInfo?: Maybe<SubscriptionInfo>;
};

export type PendingPlaySlipOrder = PlaySlipOrder & {
  __typename?: 'PendingPlaySlipOrder';
  firstDrawDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  licensedTerritory: Scalars['String']['output'];
  lotteryId: LotteryId;
  nextDrawDate: Scalars['DateTime']['output'];
  numberOfDraws: Scalars['Int']['output'];
  numberOfPlays: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderedAt: Scalars['DateTime']['output'];
  selectedAddOns: Array<Scalars['String']['output']>;
  status: PlaySlipOrderStatus;
  subscriptionInfo?: Maybe<SubscriptionInfo>;
};

/** Representation of a phone number. */
export type Phone = {
  __typename?: 'Phone';
  /** The country code of the phone number. */
  countryCode: Scalars['CountryCode']['output'];
  /** The phone number without the country code. */
  number: Scalars['NationalNumber']['output'];
  /** The verification status of this phone number */
  status: VerificationPayloadStatus;
};

export type PickLottery = PrizeTierRequirements & {
  __typename?: 'PickLottery';
  pickRequirements: Array<PickRequirement>;
  type: PrizeTierRequirementsPayloadType;
};

export type PickRequirement = {
  __typename?: 'PickRequirement';
  betType: Scalars['String']['output'];
  identicalDigits?: Maybe<Scalars['Int']['output']>;
  identicalPairs?: Maybe<Scalars['Int']['output']>;
  ignoreFields: Array<Scalars['String']['output']>;
  /** One of FORWARD, BACKWARD, IGNORED */
  order: Scalars['String']['output'];
  /** @deprecated use order instead */
  orderMatters: Scalars['Boolean']['output'];
};

export type PlayInput = {
  addOns: Array<AddOnInput>;
  fields: Array<FieldInput>;
  stake: StakeInput;
};

export type PlaySlip = {
  firstDrawDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  licensedTerritory: Scalars['String']['output'];
  lotteryId: LotteryId;
  nextDrawDate: Scalars['DateTime']['output'];
  numberOfDraws: Scalars['Int']['output'];
  numberOfPlays: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderedAt: Scalars['DateTime']['output'];
  selectedAddOns: Array<Scalars['String']['output']>;
  status: PlaySlipStatus;
  /** @deprecated Please check for (optional) subscriptionInfo instead */
  subscription: Scalars['Boolean']['output'];
  subscriptionInfo?: Maybe<SubscriptionInfo>;
};

export type PlaySlipHistoryFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  lotteries?: InputMaybe<Array<LotteryId>>;
  onlyWithWinnings?: InputMaybe<Scalars['Boolean']['input']>;
  states?: InputMaybe<Array<PlaySlipStatus>>;
  subscriptionCode?: InputMaybe<Scalars['String']['input']>;
};

/** Contains a page of the current player's play slip history, split up into active, pending and closed play slips.  */
export type PlaySlipHistoryPayload = {
  __typename?: 'PlaySlipHistoryPayload';
  active: Array<ActivePlaySlip>;
  closed: Array<ClosedPlaySlip>;
  pending: Array<PendingPlaySlip>;
  totalActive: Scalars['Int']['output'];
  totalClosed: Scalars['Int']['output'];
  totalPending: Scalars['Int']['output'];
};


/** Contains a page of the current player's play slip history, split up into active, pending and closed play slips.  */
export type PlaySlipHistoryPayloadActiveArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


/** Contains a page of the current player's play slip history, split up into active, pending and closed play slips.  */
export type PlaySlipHistoryPayloadClosedArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


/** Contains a page of the current player's play slip history, split up into active, pending and closed play slips.  */
export type PlaySlipHistoryPayloadPendingArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type PlaySlipInput = {
  addOns: Array<AddOnInput>;
  bonusCode?: InputMaybe<Scalars['BonusCode']['input']>;
  configVersion: Scalars['String']['input'];
  licensedTerritory: Scalars['String']['input'];
  lotteryId: LotteryId;
  numberOfDraws: Scalars['Int']['input'];
  plays: Array<PlayInput>;
  subscription?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionOptions?: InputMaybe<SubscriptionOptionsInput>;
};

export type PlaySlipOrder = {
  firstDrawDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  licensedTerritory: Scalars['String']['output'];
  lotteryId: LotteryId;
  nextDrawDate: Scalars['DateTime']['output'];
  numberOfDraws: Scalars['Int']['output'];
  numberOfPlays: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  orderedAt: Scalars['DateTime']['output'];
  selectedAddOns: Array<Scalars['String']['output']>;
  status: PlaySlipOrderStatus;
  subscriptionInfo?: Maybe<SubscriptionInfo>;
};

export enum PlaySlipOrderStatus {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Ordered = 'ORDERED',
  Purchased = 'PURCHASED'
}

export type PlaySlipOrdersFilterInput = {
  lotteries?: InputMaybe<Array<LotteryId>>;
  status: Array<PlaySlipOrderStatus>;
  subscription?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlaySlipOrdersPayload = {
  __typename?: 'PlaySlipOrdersPayload';
  count: Scalars['Long']['output'];
  playSlipOrders: Array<PlaySlipOrder>;
};

export type PlaySlipPayload = {
  __typename?: 'PlaySlipPayload';
  id: Scalars['String']['output'];
};

export type PlaySlipPriceBreakdownInput = {
  /** Add-on charge per playSlip but not multiplied with draws */
  addOnChargePerPlaySlip: MoneyInput;
  /** Add-on fee per playSlip but not multiplied with draws */
  addOnFeePerPlaySlip: MoneyInput;
  /** Sum of all charges per draw */
  chargePerPlaySlip: MoneyInput;
  /** Sum of all charges, multiplied with number of draws */
  chargeTotal: MoneyInput;
  /** List of charges for addons */
  chargesForPlaySlipAddOns: Array<ChargeForAddOnInput>;
  /** List of charges per play */
  chargesPerPlay: Array<ChargeForPlayInput>;
  /** Sum of all fees per draw */
  feePerPlaySlip: MoneyInput;
  /** Sum of all convenience fees, multiplied with number of draws */
  feeTotal: MoneyInput;
  /** Total price including sales tax */
  grossTotal: MoneyInput;
  /** Version of the price calculation library used to calculate fees and charges */
  libraryVersion: Scalars['String']['input'];
  /** Version of the lottery configuration */
  lotteryConfigVersion: Scalars['String']['input'];
  /** Total price without sales tax */
  netTotal: MoneyInput;
  /** Number of draws */
  numberOfDraws: Scalars['Int']['input'];
  /** Number of plays */
  numberOfPlays: Scalars['Int']['input'];
  /** Charge per playSlip but not multiplied with draws */
  playChargePerPlaySlip: MoneyInput;
  /** Fee per playSlip but not multiplied with draws */
  playFeePerPlaySlip: MoneyInput;
  /** Version of the price list */
  priceListVersion: Scalars['String']['input'];
  /** Sales tax for markets where it is calculated separately */
  salesTax: MoneyInput;
};

export enum PlaySlipStatus {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  ManualReview = 'MANUAL_REVIEW',
  Ordered = 'ORDERED',
  Preliminary = 'PRELIMINARY',
  Purchased = 'PURCHASED',
  Rejected = 'REJECTED'
}

/** Response to a storePlaySlip mutation request. Contains the resulting play slip ID and if the play slip is subscribed. */
export type PlaySlipStored = {
  __typename?: 'PlaySlipStored';
  id: Scalars['String']['output'];
  subscription: Scalars['Boolean']['output'];
};

export enum PlaySlipType {
  FreeTicket = 'FREE_TICKET',
  Normal = 'NORMAL',
  PrepaidSubscription = 'PREPAID_SUBSCRIPTION',
  Subscription = 'SUBSCRIPTION'
}

export type PlaySlipValidationPayload = {
  __typename?: 'PlaySlipValidationPayload';
  success: Scalars['Boolean']['output'];
};

export enum PlayerCheckStatus {
  BelowMinimumAge = 'BELOW_MINIMUM_AGE',
  NotVerified = 'NOT_VERIFIED',
  Ok = 'OK',
  SelfBan = 'SELF_BAN',
  Suspended = 'SUSPENDED'
}

/** The current configuration of a player. */
export type PlayerConfigurationPayload = {
  __typename?: 'PlayerConfigurationPayload';
  twoFactorAuthentication: TwoFactorAuthenticationSetting;
};

export type PlayerLimit = Limit & {
  __typename?: 'PlayerLimit';
  available: Money;
  nextIncreaseFrom: Scalars['Instant']['output'];
  nextPeriodStart: Scalars['Instant']['output'];
  period: LimitPeriod;
  type: LimitType;
  value: Money;
};

/** contains the payload of the player (e.g. given name, family name) */
export type PlayerPayload = {
  __typename?: 'PlayerPayload';
  /** The physical address of the player. */
  address: Scalars['Address']['output'];
  automaticAgeVerification?: Maybe<VerificationPayload>;
  customerId: Scalars['CustomerId']['output'];
  dateOfBirth: Scalars['Date']['output'];
  didAutomaticAgeVerificationFail?: Maybe<Scalars['Boolean']['output']>;
  didAutomaticAgeVerificationSucceed?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['EMailAddress']['output'];
  /** The family name. */
  familyName: Scalars['Name']['output'];
  formattedPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** The given name. */
  givenName: Scalars['Name']['output'];
  hasAutomaticAgeVerificationStarted?: Maybe<Scalars['Boolean']['output']>;
  hasManualAgeVerification?: Maybe<Scalars['Boolean']['output']>;
  hasSendSafelyUpload?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  idologyUrl?: Maybe<Scalars['String']['output']>;
  idologyVerification?: Maybe<VerificationPayload>;
  isAutomaticAgeVerificationPending?: Maybe<Scalars['Boolean']['output']>;
  isIdologyPending?: Maybe<Scalars['Boolean']['output']>;
  isRegistered?: Maybe<Scalars['Boolean']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  locale: Scalars['LanguageTag']['output'];
  needsManualVerification?: Maybe<Scalars['Boolean']['output']>;
  /** The phone number of the player. */
  phone: Phone;
  registrationDate: Scalars['Instant']['output'];
  /** Information about an active self-exclusion if there is an active one. */
  selfExclusion?: Maybe<PlayerSelfExclusionPayload>;
  shouldVerifyPhone?: Maybe<Scalars['Boolean']['output']>;
  /** The current status of the player. */
  status: Status;
  /** The verifications concerning the player. */
  verifications: Array<VerificationPayload>;
};

export enum PlayerRestriction {
  NotVerified = 'NotVerified',
  Ok = 'Ok'
}

/** Information about a self-exclusion. */
export type PlayerSelfExclusionPayload = {
  __typename?: 'PlayerSelfExclusionPayload';
  /** The point in time at which the players' self-exclusion will end. */
  expires: Scalars['Instant']['output'];
  type: SelfExclusionType;
};

export type PlaysMultipleLines = {
  __typename?: 'PlaysMultipleLines';
  /** A list of addons with values of the play slip for the respective draw */
  addOnValues: Array<AddOnOutput>;
  /** A list of all available addons for this draw's lottery */
  addOns: Array<AddOnOutput>;
  /** The list of fields with matches (if evaluated) */
  fields: Array<FieldWithMatches>;
  /** The serial number of the play slip */
  serialNumber: Scalars['String']['output'];
  /** The status of the play slip */
  state: PlaySlipStatus;
  /** The monetary or free ticket winnings (if evaluated) */
  winnings: WinningMultipleLines;
};

export type PreferenceInput = {
  channel: NotificationChannel;
  notification: Notification;
  selected: Scalars['Boolean']['input'];
};

export type PreferencePayload = {
  __typename?: 'PreferencePayload';
  channels: Array<ChannelPayload>;
  notification: Notification;
};

export type PreferencesInput = {
  preferences: Array<PreferenceInput>;
};

export type PrepaidOptions = {
  __typename?: 'PrepaidOptions';
  participatedDraws: Scalars['Int']['output'];
  remainingDraws: Scalars['Int']['output'];
  totalDraws: Scalars['Int']['output'];
};

export type PrepaidSubscriptionsConfig = {
  __typename?: 'PrepaidSubscriptionsConfig';
  customDrawsMax: Scalars['Int']['output'];
  customDrawsMin: Scalars['Int']['output'];
  selectableDrawsOptions: Array<Scalars['Int']['output']>;
};

export type PriceBreakdown = {
  __typename?: 'PriceBreakdown';
  /** Add-on charge per playSlip but not multiplied with draws */
  addOnChargePerPlaySlip: Money;
  /** Add-on fee per playSlip but not multiplied with draws */
  addOnFeePerPlaySlip: Money;
  /** Sum of all charges per draw */
  chargePerPlaySlip: Money;
  /** Sum of all charges, multiplied with number of draws */
  chargeTotal: Money;
  /** List of charges for addons */
  chargesForPlaySlipAddOns: Array<ChargeForAddOn>;
  /** List of charges per play */
  chargesPerPlay: Array<ChargeForPlay>;
  /** Sum of all fees per draw */
  feePerPlaySlip: Money;
  /** Sum of all convenience fees, multiplied with number of draws */
  feeTotal: Money;
  /** Total price including sales tax */
  grossTotal: Money;
  /** Version of the price calculation library used to calculate fees and charges */
  libraryVersion: Scalars['String']['output'];
  /** Version of the lottery configuration */
  lotteryConfigVersion: Scalars['String']['output'];
  /** Total price without sales tax */
  netTotal: Money;
  /** Number of draws */
  numberOfDraws: Scalars['Int']['output'];
  /** Number of plays */
  numberOfPlays: Scalars['Int']['output'];
  /** Charge per playSlip but not multiplied with draws */
  playChargePerPlaySlip: Money;
  /** Fee per playSlip but not multiplied with draws */
  playFeePerPlaySlip: Money;
  /** Version of the price list */
  priceListVersion: Scalars['String']['output'];
  /** Sales tax for markets where it is calculated separately */
  salesTax: Money;
};

export type PriceListPayload = {
  __typename?: 'PriceListPayload';
  charges: Array<Charge>;
  fees: Array<Fee>;
  lotteryId: LotteryId;
  salesTaxStrategy: SalesTaxStrategy;
  version: Scalars['String']['output'];
};

export type PricePoint = {
  __typename?: 'PricePoint';
  amount: Money;
  fees: Money;
  isMostPopular: Scalars['Boolean']['output'];
  totalAmount: Money;
  /** If the amount + the calculated fees exceed any of the deposit limits */
  withinFundingLimit: Scalars['Boolean']['output'];
};

export enum PriceType {
  Draw = 'DRAW',
  Once = 'ONCE',
  Week = 'WEEK'
}

export type Prize = PrizePayload & {
  __typename?: 'Prize';
  prize: Money;
  tier: Scalars['String']['output'];
  tierInfo: PrizeTier;
  type: PrizeTierType;
  winners: Scalars['Int']['output'];
};

export type PrizeCategory = {
  __typename?: 'PrizeCategory';
  group: Scalars['DrawnNumbersGroup']['output'];
  /** @deprecated Use group instead */
  lotteryId: LotteryId;
  name: Scalars['String']['output'];
  prizes: Array<PrizePayload>;
};

export type PrizePayload = {
  prize?: Maybe<Money>;
  tier: Scalars['String']['output'];
  tierInfo: PrizeTier;
  type: PrizeTierType;
  winners: Scalars['Int']['output'];
};

export type PrizeTier = {
  __typename?: 'PrizeTier';
  amount?: Maybe<Money>;
  jackpot: Scalars['Boolean']['output'];
  /** How likely it is to win 1:odds */
  odds: Scalars['Long']['output'];
  payoutInterval: PayoutInterval;
  requirements: PrizeTierRequirements;
  tier: Scalars['String']['output'];
  type: PrizeTierType;
};

export type PrizeTierCategory = {
  __typename?: 'PrizeTierCategory';
  categoryRequirements: Array<PrizeTierCategoryRequirements>;
  group: Scalars['DrawnNumbersGroup']['output'];
  name: Scalars['String']['output'];
  prizeTiers: Array<PrizeTier>;
  /** @deprecated Contains only the first requirement, use categoryRequirements instead, replace with categoryRequirements */
  requirements?: Maybe<PrizeTierCategoryRequirements>;
};

export type PrizeTierCategoryRequirements = {
  type: PrizeTierCategoryRequirementsPayloadType;
};

export enum PrizeTierCategoryRequirementsPayloadType {
  AlwaysActive = 'ALWAYS_ACTIVE',
  ByAddonSelected = 'BY_ADDON_SELECTED',
  ByMultiplierDeselected = 'BY_MULTIPLIER_DESELECTED',
  ByMultiplierSelected = 'BY_MULTIPLIER_SELECTED',
  ByMultiplierValueMatched = 'BY_MULTIPLIER_VALUE_MATCHED',
  /** @deprecated Will be removed in the future */
  LotterySpecific = 'LOTTERY_SPECIFIC'
}

export type PrizeTierRequirements = {
  type: PrizeTierRequirementsPayloadType;
};

export enum PrizeTierRequirementsPayloadType {
  /** @deprecated Will be removed in the future */
  LotterySpecific = 'LOTTERY_SPECIFIC',
  LuckyLines = 'LUCKY_LINES',
  NumberLottery = 'NUMBER_LOTTERY',
  PickLottery = 'PICK_LOTTERY'
}

export enum PrizeTierType {
  Fixed = 'FIXED',
  FreeTicket = 'FREE_TICKET',
  Jackpot = 'JACKPOT'
}

export type Product = LotteryProduct | ScratchcardProduct;

export enum ProductType {
  Lottery = 'Lottery',
  LotterySubscription = 'LotterySubscription',
  Scratchcard = 'Scratchcard'
}

export type PxpCreditCardInput = {
  accountId: Scalars['String']['input'];
  paymentId: Scalars['String']['input'];
  providerData?: InputMaybe<PxpCreditCardProviderDataInput>;
  specificType?: InputMaybe<Scalars['String']['input']>;
};

export type PxpCreditCardProviderDataInput = {
  accountFundingSource?: InputMaybe<Scalars['String']['input']>;
  cardNumber: Scalars['String']['input'];
  cardToken: Scalars['String']['input'];
  cardType: Scalars['String']['input'];
  expiryMonth: Scalars['Int']['input'];
  expiryYear: Scalars['Int']['input'];
  holderName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  issuerCountryCode?: InputMaybe<Scalars['String']['input']>;
  issuerName?: InputMaybe<Scalars['String']['input']>;
  paymentAccountTypeID: Scalars['Int']['input'];
  paymentMethodID: Scalars['Int']['input'];
};

export type Query = {
  __typename?: 'Query';
  account: AccountPayload;
  /** Retrieves the active announcement for a given licensed territory (or null) */
  activeAnnouncement?: Maybe<AnnouncementQueryResponse>;
  /**
   *
   * Prepares a payment to add funds to the player's account.
   * Possible errors:
   * - internal.error In case of a server error.
   * - authentication.noauthheader If the player is not logged in.
   * - validation.addfunds.fundinglimitexceeded If none of the price points is lower or equal to the player's funding limit.
   *
   */
  addFundsConfig: AddFundsConfigPayload;
  /**
   *
   * Queries for the status of the add funds process with the given ID
   * Possible errors:
   * - internal.error In case of a server error.
   * - authentication.noauthheader If the player is not logged in.
   * - validation.addfunds.notfound If the add funds process can not be found for the given ID
   * - validation.addfunds.invalidpaymentid If the payment associated with the add funds can not be found
   * - validation.addfunds.invalidfundingid If the passed ID has an incorrect format.
   *
   */
  addFundsStatus: AddFundsStatusPayload;
  /**
   *
   * Requests an Apple Pay payment session for merchant validation.
   * Possible errors:
   * - authentication.noauthheader If the player is not logged in.
   * - internal.error For any other error.
   *
   */
  applePayMerchantValidation: ApplePayMerchantValidationPayload;
  /**
   *
   *             Returns information about the given bonus code, like type, value and descriptions.
   *             Possible errors are:
   *             - internal.error: Unexpected internal error
   *             - bonus.code.invalid: The code is either invalid or not enabled
   *             - bonus.code.expired: The promotion the code belongs to has expired
   *
   */
  bonusCodeInfo: BonusCodeInfoPayload;
  /**
   *
   *             Validates a bonus code with the given context information. The player can be optionally logged in.
   *             If not logged in, they will be treated as a new customer.
   *             If the code is valid and can possibly be redeemed, a BonusCodePayload object with details is returned.
   *             If the code cannot be redeemed, one of the following errors is returned:
   *             - internal.error: Unexpected internal error
   *             - precondition.failed: The chargesPerPlay from the bonus code input is empty (only play slips)
   *             - bonus.code.invalid: The code is either invalid or not enabled
   *             - bonus.code.expired: The promotion the code belongs to has expired
   *             - bonus.code.redeemed: The code has already been redeemed the maximum amount of uses for this player (logged in only)
   *             - bonus.code.noredemptions: The limit of redemptions for this code has been exceeded
   *             - bonus.code.invalidfordrawgames: The code is not applicable to draw games
   *             - bonus.code.invalidforscratchgames: The code is not applicable to scratch games
   *
   * @deprecated Please use checkBonusCodeForPlaySlip, replace with checkBonusCodeForPlaySlip
   */
  checkBonusCode: BonusValidationResult;
  /**
   *
   *             Validates a bonus code for a play slip with the given context information. The player can be optionally logged in.
   *             If not logged in, they will be treated as a new customer.
   *             If the code is valid and can possibly be redeemed, a BonusCodePayload object with details is returned.
   *             If the code cannot be redeemed, one of the following errors is returned:
   *             - internal.error: Unexpected internal error
   *             - precondition.failed: The chargesPerPlay from the bonus code input is empty
   *             - bonus.code.invalid: The code is either invalid or not enabled
   *             - bonus.code.expired: The promotion the code belongs to has expired
   *             - bonus.code.redeemed: The code has already been redeemed the maximum amount of uses for this player (logged in only)
   *             - bonus.code.noredemptions: The limit of redemptions for this code has been exceeded
   *             - bonus.code.invalidfordrawgames: The code is not applicable to draw games
   *             - bonus.code.invalidforscratchgames: The code is not applicable to scratch games
   *
   */
  checkBonusCodeForPlaySlip: BonusValidationResult;
  checkRoutingNumber: CheckRoutingNumberPayload;
  cookies?: Maybe<Scalars['String']['output']>;
  /**
   *
   *             Creates a list of teasers for the provided product type (lottery or scratchcard).
   *             Possible errors are:
   *             - internal.error: Unexpected internal error
   *             - validation.licensedterritory.invalid: The licensed territory is invalid
   *
   */
  defaultTeasers: DefaultTeasersPayload;
  /**
   *
   *         Returns all the draw information for the given draw ID.
   *         Possible errors:
   *         - draw.notfound if there is no draw for the given ID
   *         - lottery.notfound if there is no lottery configuration valid at the draw's draw date
   *
   */
  drawDetail: FinishedDrawPayload;
  /**
   *
   *         Returns all matching draws for which numbers have been entered.
   *         Valid limits are 1-50.
   *         Valid offsets are >= 0.
   *
   */
  drawHistory: DrawHistoryPayload;
  /**
   *
   *         Returns the latest finished draw for each active lottery in the given licensed territory,
   *         grouped by day in the licensed territory's time zone.
   *
   */
  drawListByDay: DrawHistoryByDayPayload;
  /**
   *
   *         Returns the previous and following draw IDs for the given draw ID.
   *
   *         Possible errors:
   *         - draw.notfound - if there is no draw for the given ID
   *         - error.internalServer - if a database error occurs
   *
   */
  drawNavigation: DrawNavigationPayload;
  /** Hype specific validations */
  hypeValidations: HypeValidationsPayload;
  /**
   *
   * Lists all available payment instruments the user can create.
   *
   */
  initialPaymentInstruments: Array<InitialPaymentInstrumentsPayload>;
  /**
   *
   *         Returns the latest finished draw for each active lottery in the given licensed territory.
   *
   */
  latestDraws: DrawHistoryPayload;
  limits: Limits;
  lotteries: Array<LotteryPayload>;
  lottery: LotteryPayload;
  /** Get a list of lottery teasers containing information about next draw and jackpot sorted by next closing date (ascending) */
  lotteryTeasers: Array<LotteryTeaserPayload>;
  /** Returns the marketing notification preferences for the player. */
  marketingPreferences: MarketingPreferencesPayload;
  nextDraw?: Maybe<DrawPayload>;
  noop: Scalars['String']['output'];
  /** Returns status PENDING while the payment is being processed */
  order: Order;
  /**
   *
   *         The type of products the current player already purchased. Only successful purchases are considered.
   *
   *         Even though subscription is technically a product of type 'LOTTERY', it is included as a separate option.
   *
   */
  orderedType: OrderedTypePayload;
  /**
   *
   *         Lists all pay out accounts for the logged-in player.
   *         Pay out is restricted, if the player is not (yet) verified.
   *         If PayPal is active and the logged-in player has successfully deposited
   *         via PayPal, then only the PayPal pay out account is listed.
   *
   */
  payOutAccounts: PayOutOptions;
  /**
   *
   * Just the list of available payment methods.
   * If a payment method is available from different providers, it will only be returned once.
   *
   */
  paymentMethods: Array<PaymentMethod>;
  /**
   *
   *         Returns the play slip history for a player, split up into active, pending and closed play slips.
   *         Paging is applied to all selected lists.
   *
   */
  playSlipHistory: PlaySlipHistoryPayload;
  /**
   *
   *         Returns all play slip orders for the given filter.
   *
   *         Offset must be at least 0.
   *         Limit (page size) will be limited to max 50 and at least 1.
   *
   *         If the filter status is empty, an empty list will be returned.
   *
   *         Possible errors:
   *         - playslips.notfound: If there are no play slips found for the play slip order given the filter criteria.
   *         - error.internalserver - if a database error occurs
   *
   */
  playSlipOrders: PlaySlipOrdersPayload;
  player: PlayerPayload;
  /**
   *
   * Get the current configuration of a logged-in player.
   * A configuration contains technical settings on the platform that are not related to the master data of a player.
   *
   * @deprecated use twoFactorConfiguration instead
   */
  playerConfiguration: PlayerConfigurationPayload;
  playerSignupFinished: SignupFinishedPayload;
  /** Returns a list of notification preferences for the current user, grouped by notification type. */
  preferences: Array<PreferencePayload>;
  priceList?: Maybe<PriceListPayload>;
  /**
   *
   *             Returns 2 personalized recommendations for a player based on their purchased product.
   *             `licensedTerritory` must be a valid licensed territory. Required.
   *             `purchasedProductType` must be either LOTTERY or SCRATCHCARD. Required.
   *             `purchasedProductSubtype` must be a lottery ID or scratchcard game slug. Required.
   *             `playerId` This is used if the query has neither a player authorization or soft login cookie information. Optional.
   *             Possible errors are:
   *             - internal.error: Unexpected internal error
   *             - validation.licensedterritory.invalid: The licensed territory is invalid
   *
   */
  recommendations: TeasersPayload;
  scheduledDraws: Array<DrawPayload>;
  /**
   *
   *             Queries a specific scratchcard game by licensed territory and game slug.
   *
   *             Possible error codes:
   *             - validation.licensedterritory.invalid - if the licensed territory has an invalid format
   *             - validation.licensedterritory.unknown - if the licensed territory is not configured
   *             - validation.slug.invalid - if the given game slug has an invalid format
   *             - validation.game.notfound - if the game could not be found
   *             - error.internalserver - if a database error occurs
   *
   */
  scratchcardGame: ScratchcardGame;
  /** Returns the order details for one scratchcard order of the current player. */
  scratchcardOrder: ScratchcardOrderDetail;
  /** Returns the paginated list of scratchcard orders for a player. */
  scratchcardOrders: ScratchcardOrdersPayload;
  /**
   *
   *             Lists the teasers for all enabled and available scratchcard games, sorted descending by max prize.
   *
   *             Possible error codes:
   *             - validation.licensedterritory.invalid - if the licensed territory has an invalid format
   *             - validation.licensedterritory.unknown - if the licensed territory is not configured
   *             - error.internalserver - if a database error occurs
   *
   */
  scratchcardTeasers: Array<ScratchcardTeaser>;
  /**
   *
   *         Returns all ticket details of a single play slip order given by its order ID
   *         including potential winnings and draw results.
   *
   *         Possible error codes:
   *         - validation.playsliporder.unknown: The play slip order could not be found
   *         - pricelist.notfound: The price list could not be found
   *         - error.internalserver: If a database error occurs
   *
   */
  singleOrderMultipleLines: SingleOrderMultipleLines;
  /** Returns state PENDING if no play slip found for the given productId */
  singleProductCheckout: CheckoutPayload;
  /**
   *
   * Lists the active payment instruments (pay-in and pay-out) for a player.
   * Possible errors:
   * - licensedterritory.error.invalid: If the licensed territory is unknown
   * - authentication.noauthheader: If the authentication header is missing
   * - error.databaseerror: If the database cannot be found
   * - internal.error: If an unexpected error occurred while looking up the stored payment instruments in the database
   *
   */
  storedPaymentInstruments: StoredPaymentInstruments;
  /**
   *
   *         Returns subscription details for the provided subscription by its order ID.
   *
   */
  subscriptionOrderMultipleLines: SubscriptionOrderMultipleLinesPayload;
  /**
   *
   *         Returns all subscriptions for the given filter.
   *
   *         Valid values for the limit are 1 to 50.
   *         Valid values for offset are at least 0.
   *
   */
  subscriptionsMultipleLines: SubscriptionsMultipleLines;
  /**
   *
   *             Creates a list of teasers from active lotteries and active scratchcard games.
   *             Possible errors are:
   *             - internal.error: Unexpected internal error
   *             - validation.licensedterritory.invalid: The licensed territory is invalid
   *
   */
  teasers: TeasersPayload;
  /**
   *
   *         Returns a paged list of the current user's transactions, newest first.
   *
   *         Parameters:
   *         - offset: Index of the first transaction to return. Use 0 to retrieve the most recent transaction
   *         - limit: The page size, 1 to 20
   *
   *         Possible error codes:
   *         - validation.accountnotfound if no account exists for the current user
   *
   */
  transactionHistory: TransactionHistory;
  /** Get the current two factor configuration of a logged-in player. */
  twoFactorConfiguration: TwoFactorConfigurationPayload;
  validatePlaySlip: PlaySlipValidationPayload;
};


export type QueryActiveAnnouncementArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type QueryAddFundsConfigArgs = {
  input?: InputMaybe<AddFundsInput>;
  licensedTerritory: Scalars['String']['input'];
};


export type QueryAddFundsStatusArgs = {
  id: Scalars['String']['input'];
};


export type QueryApplePayMerchantValidationArgs = {
  input: ApplePayMerchantValidationInput;
};


export type QueryBonusCodeInfoArgs = {
  code: Scalars['String']['input'];
};


export type QueryCheckBonusCodeArgs = {
  input: BonusCodeValidationInput;
};


export type QueryCheckBonusCodeForPlaySlipArgs = {
  input: BonusCodeValidationInput;
};


export type QueryCheckRoutingNumberArgs = {
  routingNumber: Scalars['String']['input'];
};


export type QueryDefaultTeasersArgs = {
  licensedTerritory: Scalars['String']['input'];
  productType: KnownProductType;
};


export type QueryDrawDetailArgs = {
  id: Scalars['String']['input'];
};


export type QueryDrawHistoryArgs = {
  filter?: InputMaybe<DrawResultsFilterInput>;
  licensedTerritory: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryDrawListByDayArgs = {
  filter?: InputMaybe<DrawResultsFilterInput>;
  licensedTerritory: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryDrawNavigationArgs = {
  drawId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInitialPaymentInstrumentsArgs = {
  input: InitialPaymentInstrumentsInput;
};


export type QueryLatestDrawsArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type QueryLotteriesArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type QueryLotteryArgs = {
  id: LotteryId;
  licensedTerritory: Scalars['String']['input'];
};


export type QueryLotteryTeasersArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type QueryNextDrawArgs = {
  licensedTerritory: Scalars['String']['input'];
  lotteryId: LotteryId;
};


export type QueryOrderArgs = {
  id: Scalars['OrderId']['input'];
};


export type QueryPayOutAccountsArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type QueryPaymentMethodsArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type QueryPlaySlipHistoryArgs = {
  filter?: InputMaybe<PlaySlipHistoryFilterInput>;
};


export type QueryPlaySlipOrdersArgs = {
  filter: PlaySlipOrdersFilterInput;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryPriceListArgs = {
  licensedTerritory: Scalars['String']['input'];
  lotteryId: LotteryId;
};


export type QueryRecommendationsArgs = {
  licensedTerritory: Scalars['String']['input'];
  purchasedProductSubtype: Scalars['String']['input'];
  purchasedProductType: KnownProductType;
};


export type QueryScheduledDrawsArgs = {
  licensedTerritory: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  lotteryId: LotteryId;
};


export type QueryScratchcardGameArgs = {
  licensedTerritory: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryScratchcardOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryScratchcardOrdersArgs = {
  filter: ScratchcardsFilterInput;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryScratchcardTeasersArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type QuerySingleOrderMultipleLinesArgs = {
  orderId: Scalars['String']['input'];
};


export type QuerySingleProductCheckoutArgs = {
  licensedTerritory: Scalars['String']['input'];
  productId: Scalars['ProductId']['input'];
};


export type QueryStoredPaymentInstrumentsArgs = {
  input: StoredPaymentInstrumentsInput;
};


export type QuerySubscriptionOrderMultipleLinesArgs = {
  orderId: Scalars['String']['input'];
};


export type QuerySubscriptionsMultipleLinesArgs = {
  filter: SubscriptionsFilterInput;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryTeasersArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type QueryTransactionHistoryArgs = {
  filter?: InputMaybe<ShopTransactionsFilterInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryValidatePlaySlipArgs = {
  input: PlaySlipInput;
};

export type QuickPickConfiguration = {
  __typename?: 'QuickPickConfiguration';
  addOns: Array<AddOnOutput>;
  plays: Scalars['Int']['output'];
};

export type ReformattedDrawPayload = {
  __typename?: 'ReformattedDrawPayload';
  addOns: Array<Scalars['String']['output']>;
  drawDate: Scalars['DateTime']['output'];
  drawnNumbers: Array<ReformattedDrawnNumbers>;
  hasMultipleDrawsOnDay: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  label: DrawLabel;
  lotteryConfig: LotteryPayload;
  /** ID of the main lottery. */
  lotteryId: LotteryId;
  prizeCategories: Array<PrizeCategory>;
};

export type ReformattedDrawnNumbers = {
  __typename?: 'ReformattedDrawnNumbers';
  /** ID of the main lottery or additional lottery, like 'GREENBALL' */
  name: Scalars['String']['output'];
  numbers: Array<Numbers>;
  /** For lotteries like GlücksSpirale or ElGordo where the numbers are drawn per rank */
  rank?: Maybe<Scalars['String']['output']>;
  /** For spiel77 / super6 which only have one single number */
  singleNumber: Scalars['Boolean']['output'];
};

/** The data needed to identify the player for the password reset token request. */
export type RequestPasswordResetInput = {
  dateOfBirth: Scalars['Date']['input'];
  email: Scalars['UnvalidatedEMailAddress']['input'];
  licensedTerritory: Scalars['LicensedTerritory']['input'];
};

/** The result of the password reset token request. Will always indicate a success. */
export type RequestPasswordResetPayload = {
  __typename?: 'RequestPasswordResetPayload';
  result: RequestPasswordResetResult;
};

/** The possible results of a password reset token request. */
export enum RequestPasswordResetResult {
  /** Indicates a successful password reset token request. */
  Success = 'Success'
}

export type ResendCodeMutationInput = {
  countryCode: Scalars['String']['input'];
  nationalNumber: Scalars['String']['input'];
};

export type ResendCodePayload = {
  __typename?: 'ResendCodePayload';
  countryCode: Scalars['String']['output'];
  nationalNumber: Scalars['String']['output'];
};

export type ReserveScratchcardsInput = {
  gameSlug: Scalars['String']['input'];
  licensedTerritory: Scalars['String']['input'];
  /** The amount of scratchcards to reserve. 1 to 10 */
  quantity: Scalars['Int']['input'];
};

export type Restrictions = {
  __typename?: 'Restrictions';
  depositLimit?: Maybe<ExceededLimit>;
  geoCheck: GeoCheckStatus;
  playerCheck: PlayerCheckStatus;
  spendingLimit?: Maybe<ExceededLimit>;
};

export type ResultsMultipleLines = {
  __typename?: 'ResultsMultipleLines';
  drawDate: Scalars['DateTime']['output'];
  hasMultipleDrawsOnDay: Scalars['Boolean']['output'];
  hasWinnings: Scalars['Boolean']['output'];
  label: DrawLabel;
  lotteryResults: Array<LotteryResultsMultipleLines>;
  ticketScanUrlsExpirationDate: Scalars['DateTime']['output'];
  ticketScans: Array<TicketScansMultipleLines>;
  totalNumberOfFreePlays?: Maybe<Scalars['Int']['output']>;
  totalWinnings?: Maybe<Money>;
};

export type RevealOrderInput = {
  orderId: Scalars['String']['input'];
};

export type RevealScratchcardInput = {
  orderId: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export enum SalesTaxStrategy {
  Es = 'ES',
  Mx = 'MX',
  NoSalesTax = 'NO_SALES_TAX',
  UsAr = 'US_AR',
  UsCo = 'US_CO',
  UsFl = 'US_FL',
  UsMn = 'US_MN',
  UsNj = 'US_NJ',
  UsNy = 'US_NY',
  UsOr = 'US_OR',
  UsTx = 'US_TX'
}

export type SavedPayOutInput = {
  amount: MoneyInput;
  idempotencyKey: Scalars['String']['input'];
  licensedTerritory: Scalars['String']['input'];
  payOutAccountId: Scalars['String']['input'];
};

export enum ScratchArea {
  Bottom = 'BOTTOM',
  Center = 'CENTER',
  Top = 'TOP'
}

export type ScratchcardDetail = {
  __typename?: 'ScratchcardDetail';
  image?: Maybe<Scalars['String']['output']>;
  images?: Maybe<ImagesPayload>;
  serialNumber: Scalars['String']['output'];
  status: ScratchcardState;
  /** @deprecated Use winningsPayload instead */
  winnings?: Maybe<Money>;
  winningsPayload?: Maybe<WinningsPayload>;
};

export type ScratchcardGame = {
  __typename?: 'ScratchcardGame';
  available: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priceList: ScratchcardPriceList;
  prizeTiers: Array<ScratchcardPrizeTier>;
  slug: Scalars['String']['output'];
  visualParameters: ScratchcardVisualParameters;
};

export type ScratchcardOrderDetail = {
  __typename?: 'ScratchcardOrderDetail';
  gameName: Scalars['String']['output'];
  licensedTerritory: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  price: Money;
  quantity: Scalars['Int']['output'];
  /** Quantity of scratchcards which were not viewed yet */
  quantityActive: Scalars['Int']['output'];
  /** Quantity of scratchcards which were already viewed */
  quantityRevealed: Scalars['Int']['output'];
  scratchcards: Array<ScratchcardDetail>;
  state: ScratchcardState;
  visualParameters: ScratchcardVisualParameters;
  winnings?: Maybe<Money>;
};

export type ScratchcardOrderPayload = {
  __typename?: 'ScratchcardOrderPayload';
  gameName: Scalars['String']['output'];
  gameSlug: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  /** Quantity of scratchcards which were not viewed yet */
  quantityActive: Scalars['Int']['output'];
  /** Quantity of scratchcards which were already viewed */
  quantityPast: Scalars['Int']['output'];
  state: ScratchcardState;
  /** Color hex string, e.g. '#FF00AB' */
  titleColor: Scalars['String']['output'];
  winnings?: Maybe<Money>;
};

export type ScratchcardOrdersPayload = {
  __typename?: 'ScratchcardOrdersPayload';
  count: Scalars['Long']['output'];
  orders: Array<ScratchcardOrderPayload>;
};

export type ScratchcardPriceBreakdown = {
  __typename?: 'ScratchcardPriceBreakdown';
  /** Flat charge per order */
  chargeForOrder: Money;
  /** Sum of all charges */
  chargeTotal: Money;
  /** Sum of the charges for scratchcards */
  chargesForCards: Money;
  /** Flat fee per order */
  feeForOrder: Money;
  /** Sum of all convenience fees, */
  feeTotal: Money;
  /** Sum of the fees for scratchcards */
  feesForCards: Money;
  /** Total price including sales tax */
  grossTotal: Money;
  /** Total price without sales tax */
  netTotal: Money;
  /** Quantity of reserved scratchcards */
  quantity: Scalars['Int']['output'];
  /** Sales tax for markets where it is calculated separately */
  salesTax: Money;
};

export type ScratchcardPriceList = {
  __typename?: 'ScratchcardPriceList';
  chargePerCard: Money;
  chargePerOrder: Money;
  currency: Scalars['String']['output'];
  feePerCard: Money;
  feePerOrder: Money;
  salesTaxStrategy: Scalars['String']['output'];
};

export type ScratchcardPrizeTier = {
  __typename?: 'ScratchcardPrizeTier';
  prize: Money;
  tier: Scalars['Int']['output'];
};

export type ScratchcardProduct = {
  __typename?: 'ScratchcardProduct';
  expiresAt: Scalars['DateTime']['output'];
  /** @deprecated Use `productName` - which contains the actual name instead of a key - instead */
  name: Scalars['String']['output'];
  price: Money;
  priceBreakdown: ScratchcardPriceBreakdown;
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  reservationId: Scalars['String']['output'];
};

export type ScratchcardReservation = {
  __typename?: 'ScratchcardReservation';
  quantity?: Maybe<Scalars['Int']['output']>;
  reservationId?: Maybe<Scalars['String']['output']>;
  restrictions?: Maybe<Restrictions>;
};

export enum ScratchcardState {
  Cancelled = 'CANCELLED',
  InProgress = 'IN_PROGRESS',
  Purchased = 'PURCHASED',
  Revealed = 'REVEALED',
  Scratched = 'SCRATCHED'
}

export type ScratchcardTeaser = {
  __typename?: 'ScratchcardTeaser';
  /** @deprecated Use visualParameters.titleColor instead */
  color: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pricePerCard: Money;
  slug: Scalars['String']['output'];
  /** @deprecated Use visualParameters.teaserImage instead */
  teaserImage?: Maybe<Scalars['String']['output']>;
  /** The maximum prize value for this game */
  value: Money;
  visualParameters: ScratchcardVisualParameters;
};

export type ScratchcardTeaserPayload = TeaserPayload & {
  __typename?: 'ScratchcardTeaserPayload';
  amount?: Maybe<Money>;
  campaign?: Maybe<CampaignPayload>;
  name: Scalars['String']['output'];
  price?: Maybe<Money>;
  slug: Scalars['String']['output'];
  visualParameters?: Maybe<ScratchcardVisualParameters>;
};

export type ScratchcardVisualParameters = {
  __typename?: 'ScratchcardVisualParameters';
  /** Color hex string, e.g. '#FF00AB' */
  primaryColor?: Maybe<Scalars['String']['output']>;
  scratchArea: ScratchArea;
  /** Color hex string, e.g. '#FF00AB' */
  secondaryColor?: Maybe<Scalars['String']['output']>;
  teaserImage?: Maybe<Scalars['String']['output']>;
  /** Optional teaser image properties, like width and height and blur hash */
  teaserImageProperties?: Maybe<ImagePropertiesPayload>;
  teaserImageUrl?: Maybe<Scalars['String']['output']>;
  /** Color hex string, e.g. '#FF00AB' */
  titleColor: Scalars['String']['output'];
};

export type ScratchcardsFilterInput = {
  status: Array<ScratchcardState>;
};

/** All data needed to self-exclude a player. */
export type SelfExclusionInput = {
  /** Number of days for the duration of the exclusion. The minimum value is 3 days. Values <= 93 will result in a Cool-Off state. */
  duration: Scalars['Int']['input'];
  licensedTerritory: Scalars['LicensedTerritory']['input'];
};

/** The return value of a self-exclusion mutation. */
export type SelfExclusionPayload = {
  __typename?: 'SelfExclusionPayload';
  /** The point in time at which the players' self-exclusion will end. */
  expires: Scalars['Instant']['output'];
  /** The new status of the player. */
  status: Status;
  /** The type of self exclusion, based on the length */
  type: SelfExclusionType;
};

/** The type of self-exclusion, currently defined by its length. */
export enum SelfExclusionType {
  CoolOff = 'CoolOff',
  SelfExclusion = 'SelfExclusion'
}

export type SetScanVerifyUploadStatusInput = {
  success: Scalars['Boolean']['input'];
};

export type ShopTransactionsFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  types?: InputMaybe<Array<TransactionType>>;
};

/** Result of a 'playerSignupFinished' query. If the player exists, the result will be `true` */
export type SignupFinishedPayload = {
  __typename?: 'SignupFinishedPayload';
  /** player exists */
  exists: Scalars['Boolean']['output'];
};

export type SingleOrderMultipleLines = {
  __typename?: 'SingleOrderMultipleLines';
  firstDrawDate: Scalars['DateTime']['output'];
  /** Internal ID of the play slip order */
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  lottery: LotteryPayload;
  nextDrawDate?: Maybe<Scalars['DateTime']['output']>;
  nextOrderId?: Maybe<Scalars['String']['output']>;
  numberOfDraws: Scalars['Int']['output'];
  /**
   *
   *             Determines if the ticket has any winnings. May be true even if `winnings`
   *             are 0, because of other types of winnings (e.g. free ticket).
   *
   */
  orderId: Scalars['String']['output'];
  /** The ISO code of the licensed territory the order was created in, e.g. US-NJ */
  orderedIn: Scalars['String']['output'];
  previousOrderId?: Maybe<Scalars['String']['output']>;
  price: Money;
  /**
   *
   *             Returns a paginated list of draw results for the play slip order.
   *             Valid values for the limit are 1 to 50.
   *             Valid values for offset are at least 0.
   *             The default values are 0 for offset and 10 for limit.
   *
   */
  results: Array<ResultsMultipleLines>;
  state: Scalars['String']['output'];
  totalDrawResults: Scalars['Int']['output'];
  type: PlaySlipType;
};


export type SingleOrderMultipleLinesResultsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Stake = {
  __typename?: 'Stake';
  /** References a price from the price list */
  price: Scalars['String']['output'];
};

export type StakeInput = {
  /** References a price from the price list */
  price: Scalars['String']['input'];
};

/** The possible statuses of a player. */
export enum Status {
  Closed = 'Closed',
  Registered = 'Registered',
  SelfExcluded = 'SelfExcluded',
  Suspended = 'Suspended',
  Verified = 'Verified'
}

export type StoredBankInstrument = StoredInstrument & {
  __typename?: 'StoredBankInstrument';
  accountHolderName: Scalars['String']['output'];
  internalId: Scalars['String']['output'];
  maskedAccountNumber: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  routingNumber: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StoredCardInstrument = StoredInstrument & {
  __typename?: 'StoredCardInstrument';
  cardholderName: Scalars['String']['output'];
  expirationDate: Scalars['String']['output'];
  expiryMonth?: Maybe<Scalars['Int']['output']>;
  expiryYear?: Maybe<Scalars['Int']['output']>;
  internalId: Scalars['String']['output'];
  maskedCardNumber: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  type: Scalars['String']['output'];
  walletType?: Maybe<Scalars['String']['output']>;
};

export type StoredInstrument = {
  internalId: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StoredInstrumentPayPal = StoredInstrument & {
  __typename?: 'StoredInstrumentPayPal';
  email: Scalars['String']['output'];
  holderName: Scalars['String']['output'];
  internalId: Scalars['String']['output'];
  maskedEmail: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StoredInstrumentVenmo = StoredInstrument & {
  __typename?: 'StoredInstrumentVenmo';
  internalId: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  type: Scalars['String']['output'];
  venmoUserId: Scalars['String']['output'];
  venmoUserName: Scalars['String']['output'];
};

export type StoredPaymentInstrument = {
  __typename?: 'StoredPaymentInstrument';
  accountId: Scalars['String']['output'];
  cardNumber?: Maybe<Scalars['String']['output']>;
  expiryMonth?: Maybe<Scalars['Int']['output']>;
  expiryYear?: Maybe<Scalars['Int']['output']>;
  holderName?: Maybe<Scalars['String']['output']>;
  /** Either CardDeposit or Redirect */
  integrationType: Scalars['String']['output'];
  /** Time when this payment instrument was last used */
  lastUsed: Scalars['DateTime']['output'];
  /** Visa, AmericanExpress, Mastercard etc. */
  method: Scalars['String']['output'];
  /** Name of the payment provider */
  provider: Scalars['String']['output'];
  /** If true, the CVV has to be resubmitted for each payment */
  requiresCvvConfirmation: Scalars['Boolean']['output'];
  /** @deprecated Stored payment instruments do not need a token */
  token: PaymentToken;
  /** For example CreditCard, PayPal etc. */
  type: Scalars['String']['output'];
  /** For example ApplePay */
  walletType?: Maybe<Scalars['String']['output']>;
};

export type StoredPaymentInstruments = {
  __typename?: 'StoredPaymentInstruments';
  activePayInInstruments: Array<StoredInstrument>;
  activePayOutInstruments: Array<StoredInstrument>;
};

export type StoredPaymentInstrumentsInput = {
  licensedTerritory: Scalars['String']['input'];
};

export enum SubscriptionCancelReason {
  BackofficeRequest = 'BACKOFFICE_REQUEST',
  BreakingChangeInLotteryConfig = 'BREAKING_CHANGE_IN_LOTTERY_CONFIG',
  Closing = 'CLOSING',
  CustomerRequest = 'CUSTOMER_REQUEST',
  InitialSubmissionFailed = 'INITIAL_SUBMISSION_FAILED',
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  LimitExceeded = 'LIMIT_EXCEEDED',
  PaymentFailed = 'PAYMENT_FAILED',
  SelfExclusion = 'SELF_EXCLUSION',
  Suspended = 'SUSPENDED',
  UnexpectedError = 'UNEXPECTED_ERROR',
  Unknown = 'UNKNOWN'
}

/** Response to a subscription mutation request. Contains the resulting subscription code and status */
export type SubscriptionInfo = {
  __typename?: 'SubscriptionInfo';
  cancelReason?: Maybe<SubscriptionCancelReason>;
  cancelledDate?: Maybe<Scalars['DateTime']['output']>;
  code: Scalars['SubscriptionCode']['output'];
  drawsPerPurchase: Scalars['Int']['output'];
  firstDraw: Scalars['DateTime']['output'];
  status: SubscriptionStatus;
  type: SubscriptionType;
};

export type SubscriptionInput = {
  code: Scalars['SubscriptionCode']['input'];
};

export type SubscriptionMultipleLines = {
  __typename?: 'SubscriptionMultipleLines';
  cancelReason?: Maybe<SubscriptionCancelReason>;
  cancelledDate?: Maybe<Scalars['DateTime']['output']>;
  /** The subscription's human readable identifier */
  code: Scalars['SubscriptionCode']['output'];
  firstDraw: Scalars['DateTime']['output'];
  /** The subscription's object ID */
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  /** The latest order ID for this subscription without suffix (e.g. '.1', '.2') */
  latestOrderId: Scalars['String']['output'];
  /** The latest play slip order ID for this subscription */
  latestPlaySlipOrderId?: Maybe<Scalars['String']['output']>;
  licensedTerritory: Scalars['String']['output'];
  lotteryId: LotteryId;
  nextDrawDate?: Maybe<Scalars['DateTime']['output']>;
  numberOfPlays: Scalars['Int']['output'];
  prepaidOptions?: Maybe<PrepaidOptions>;
  selectedAddOns: Array<Scalars['String']['output']>;
  status: SubscriptionStatus;
};

export type SubscriptionOptions = {
  __typename?: 'SubscriptionOptions';
  drawsPerPurchase: Scalars['Int']['output'];
  type: SubscriptionType;
};

export type SubscriptionOptionsInput = {
  drawsPerPurchase: Scalars['Int']['input'];
  type: SubscriptionType;
};

export type SubscriptionOrderMultipleLinesPayload = {
  __typename?: 'SubscriptionOrderMultipleLinesPayload';
  cancelReason?: Maybe<SubscriptionCancelReason>;
  cancelledDate?: Maybe<Scalars['DateTime']['output']>;
  drawsPerPurchase: Scalars['Int']['output'];
  firstDrawDate: Scalars['DateTime']['output'];
  /** Internal ID of the subscription */
  id: Scalars['String']['output'];
  lastDrawDate: Scalars['DateTime']['output'];
  latestPlaySlipOrderId: Scalars['String']['output'];
  lottery: LotteryPayload;
  nextDrawDate?: Maybe<Scalars['DateTime']['output']>;
  nextOrderId?: Maybe<Scalars['String']['output']>;
  numberOfDraws: Scalars['Int']['output'];
  numberOfPlays: Scalars['Int']['output'];
  /** The licensed territory of the subscription order. */
  orderedIn: Scalars['String']['output'];
  prepaidOptions?: Maybe<PrepaidOptions>;
  previousOrderId?: Maybe<Scalars['String']['output']>;
  price: Money;
  /**
   *
   *             Returns a paginated list of draw results for the play slip order.
   *             Valid values for the limit are 1 to 50.
   *             Valid values for offset are at least 0.
   *             The default values are 0 for offset and 10 for limit.
   *
   */
  results: Array<ResultsMultipleLines>;
  status: SubscriptionStatus;
  subscriptionCode: Scalars['SubscriptionCode']['output'];
  subscriptionType: SubscriptionType;
  totalDrawResults: Scalars['Int']['output'];
  type: PlaySlipType;
};


export type SubscriptionOrderMultipleLinesPayloadResultsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Paused = 'PAUSED'
}

export enum SubscriptionType {
  Prepaid = 'PREPAID',
  Renewing = 'RENEWING'
}

export type SubscriptionsFilterInput = {
  licensedTerritory?: InputMaybe<Scalars['String']['input']>;
  status: Array<SubscriptionStatus>;
};

export type SubscriptionsMultipleLines = {
  __typename?: 'SubscriptionsMultipleLines';
  count: Scalars['Long']['output'];
  subscriptions: Array<SubscriptionMultipleLines>;
};

export type TeaserPayload = {
  campaign?: Maybe<CampaignPayload>;
};

export type TeasersPayload = {
  __typename?: 'TeasersPayload';
  id: Scalars['String']['output'];
  teasers: Array<TeaserPayload>;
};

export type TicketScanPayload = {
  __typename?: 'TicketScanPayload';
  imageProperties: ImagePropertiesPayload;
  url: Scalars['String']['output'];
};

export type TicketScansMultipleLines = {
  __typename?: 'TicketScansMultipleLines';
  scans: Array<TicketScanPayload>;
  serialNumber: Scalars['String']['output'];
};

export type TogglePaymentInstrument = {
  __typename?: 'TogglePaymentInstrument';
  isActive: Scalars['Boolean']['output'];
  paymentInstrumentId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type TransactionHistory = {
  __typename?: 'TransactionHistory';
  total: Scalars['Long']['output'];
  transactions: Array<TransactionHistoryPayload>;
};

export type TransactionHistoryPayload = {
  __typename?: 'TransactionHistoryPayload';
  amount: Money;
  bookingDate: Scalars['Instant']['output'];
  comment: Scalars['String']['output'];
  id: Scalars['String']['output'];
  orderId?: Maybe<Scalars['String']['output']>;
  payOutId?: Maybe<Scalars['String']['output']>;
  paymentIdentifier?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentProvider?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<ProductType>;
  serviceFees?: Maybe<Money>;
  totalCharged?: Maybe<Money>;
  type: Scalars['String']['output'];
};

export enum TransactionType {
  Bonus = 'BONUS',
  Chargeback = 'CHARGEBACK',
  CreditNote = 'CREDIT_NOTE',
  DebitNote = 'DEBIT_NOTE',
  PayIn = 'PAY_IN',
  PayOut = 'PAY_OUT',
  Refund = 'REFUND',
  ReverseChargeback = 'REVERSE_CHARGEBACK',
  Stake = 'STAKE',
  Winning = 'WINNING'
}

/** Channel for a player two factor authentication */
export enum TwoFactorAuthenticationChannel {
  /** Email Channel */
  Email = 'EMAIL',
  /** SMS Channel */
  Sms = 'SMS'
}

/** Setting for a players two factor authentication configuration. */
export type TwoFactorAuthenticationChannelSettingPayload = {
  __typename?: 'TwoFactorAuthenticationChannelSettingPayload';
  activated: Scalars['Boolean']['output'];
  channel: TwoFactorAuthenticationChannel;
};

/** Setting for a players two factor authentication configuration. */
export type TwoFactorAuthenticationChannelSettingPayloadInput = {
  activated: Scalars['Boolean']['input'];
  channel: TwoFactorAuthenticationChannel;
};

/** Setting for a players two factor authentication configuration. */
export enum TwoFactorAuthenticationSetting {
  /** Use direct user communication as the second factor for authentication. */
  Notification = 'Notification',
  /** Disable two factor authentication. */
  Off = 'Off'
}

/** The current configuration of a player. */
export type TwoFactorConfigurationPayload = {
  __typename?: 'TwoFactorConfigurationPayload';
  channels: Array<TwoFactorAuthenticationChannelSettingPayload>;
};

export type Unlimited = Limit & {
  __typename?: 'Unlimited';
  period: LimitPeriod;
  type: LimitType;
};

export type UnsubscribeMarketingInput = {
  unsubscribeToken: Scalars['UUID']['input'];
};

export type UnsubscribeMarketingPayload = {
  __typename?: 'UnsubscribeMarketingPayload';
  success: Scalars['Boolean']['output'];
};

export type UploadIdentityDocumentInput = {
  identityDocumentUploadUrl: Scalars['Url']['input'];
};

export type UploadIdentityDocumentPayload = {
  __typename?: 'UploadIdentityDocumentPayload';
  receivedAt: Scalars['Instant']['output'];
};

/**
 *
 *     One verification item.
 *     | Contains the 'name' of the verification, it's status and which verification-step it depends on, if any.
 *
 */
export type VerificationPayload = {
  __typename?: 'VerificationPayload';
  dependsOn?: Maybe<VerificationPayloadName>;
  manualVerificationUrl?: Maybe<Scalars['String']['output']>;
  name: VerificationPayloadName;
  status: VerificationPayloadStatus;
};

/** A name of a verification step. */
export enum VerificationPayloadName {
  AutomaticAgeVerification = 'AutomaticAgeVerification',
  IdUploadAgeVerification = 'IDUploadAgeVerification',
  ManualAgeVerification = 'ManualAgeVerification',
  PhoneVerification = 'PhoneVerification'
}

/** A status of a verification. */
export enum VerificationPayloadStatus {
  Failure = 'Failure',
  NotStarted = 'NotStarted',
  NotSupported = 'NotSupported',
  Pending = 'Pending',
  Success = 'Success',
  UploadRetriesExhausted = 'UploadRetriesExhausted'
}

export type VerifyEmailInput = {
  silentEmailVerificationToken: Scalars['String']['input'];
};

export type VerifyEmailPayload = {
  __typename?: 'VerifyEmailPayload';
  success: Scalars['Boolean']['output'];
};

export type VerifyPhoneInput = {
  verificationCode: Scalars['String']['input'];
};

export type VerifyPhonePayload = {
  __typename?: 'VerifyPhonePayload';
  verified: Scalars['Boolean']['output'];
};

export type VersionedConfig = {
  __typename?: 'VersionedConfig';
  addOns: Array<AddOn>;
  afterPurchaseAddOns: Array<AddOn>;
  /** List of allowed numbers of plays */
  allowedPlays: Array<Scalars['Int']['output']>;
  combinedTierTable: Scalars['Boolean']['output'];
  drawDates: Array<DrawDate>;
  drawInterval: DrawInterval;
  /** If false, the lottery does not provide the number of winners */
  hasNumberOfWinners: Scalars['Boolean']['output'];
  /** If true, certain combinations may get sold out and stop being available for play */
  isLockoutLottery: Scalars['Boolean']['output'];
  jackpotType: JackpotType;
  jackpots: Array<JackpotDefinition>;
  /** @deprecated Use allowedPlays instead */
  maxPlays?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use allowedPlays instead */
  minPlays?: Maybe<Scalars['Int']['output']>;
  numberOfDraws: Array<Scalars['Int']['output']>;
  numbers: Array<NumbersConfig>;
  /** If != null, customers can purchase prepaid subscriptions */
  prepaidSubscription?: Maybe<PrepaidSubscriptionsConfig>;
  prizeTierCategories: Array<PrizeTierCategory>;
  quickPick?: Maybe<VersionedConfigQuickpicks>;
  stakes: Array<Stake>;
  /** If true, customers can purchase play slip subscriptions */
  subscriptionsAllowed: Scalars['Boolean']['output'];
  type: LotteryType;
  /** ID of the first draw with the new rules */
  version: Scalars['String']['output'];
};

export type VersionedConfigQuickpicks = {
  __typename?: 'VersionedConfigQuickpicks';
  addOns: Array<AddOnOutput>;
  plays: Scalars['Int']['output'];
  validQuickPickPlays: Array<Scalars['Int']['output']>;
};

export type WinningMultipleLines = {
  __typename?: 'WinningMultipleLines';
  amount?: Maybe<Money>;
  numberOfFreePlays?: Maybe<Scalars['Int']['output']>;
};

export type WinningsPayload = {
  __typename?: 'WinningsPayload';
  amount?: Maybe<Money>;
  isBigWin: Scalars['Boolean']['output'];
  prizeTier?: Maybe<Scalars['Int']['output']>;
};

export type ZonedTime = {
  __typename?: 'ZonedTime';
  local: Scalars['LocalTime']['output'];
  zone: Scalars['String']['output'];
};

export type AccountQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountQuery = { __typename?: 'Query', account: { __typename?: 'AccountPayload', balance: { __typename: 'Money', currency: string, value: number } } };

export type AddPaymentInstrumentMutationVariables = Exact<{
  input: AddPaymentInstrumentInput;
}>;


export type AddPaymentInstrumentMutation = { __typename?: 'Mutation', addPaymentInstrument: { __typename?: 'AddPaymentInstrumentPayload', success: boolean } };

export type ChangeLimitsMutationVariables = Exact<{
  limits: LimitsInput;
  type: LimitType;
}>;


export type ChangeLimitsMutation = { __typename?: 'Mutation', changeLimitValue: Array<{ __typename: 'MaxLimit', period: LimitPeriod, type: LimitType } | { __typename: 'PlayerLimit', period: LimitPeriod, type: LimitType } | { __typename: 'Unlimited', period: LimitPeriod, type: LimitType }> };

export type ClosePlayerMutationVariables = Exact<{
  input: ClosePlayerInput;
}>;


export type ClosePlayerMutation = { __typename?: 'Mutation', closePlayer: { __typename?: 'ClosePlayerPayload', status: Status } };

export type DeactivateStoredPaymentInstrumentMutationVariables = Exact<{
  input: DeactivateStoredPaymentInstrumentInput;
}>;


export type DeactivateStoredPaymentInstrumentMutation = { __typename?: 'Mutation', deactivateStoredPaymentInstrument: { __typename?: 'TogglePaymentInstrument', success: boolean } };

export type InitialPaymentInstrumentsQueryVariables = Exact<{
  input: InitialPaymentInstrumentsInput;
}>;


export type InitialPaymentInstrumentsQuery = { __typename?: 'Query', initialPaymentInstruments: Array<{ __typename?: 'InitialPaymentInstrumentsPayload', accountId: string, integrationType: string, methods: Array<string>, provider: string, providerUri?: string | null, type: string, venmoProfileId?: string | null, token: { __typename?: 'PaymentTokenPayload', expires: string, value: string } }> };

export type LimitsQueryVariables = Exact<{
  withDeposit?: InputMaybe<Scalars['Boolean']['input']>;
  withSpending?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type LimitsQuery = { __typename?: 'Query', limits: { __typename?: 'Limits', deposit?: Array<{ __typename: 'MaxLimit', type: LimitType, period: LimitPeriod } | { __typename: 'PlayerLimit', type: LimitType, period: LimitPeriod, nextIncreaseFrom: string, nextPeriodStart: string, available: { __typename?: 'Money', currency: string, value: number }, value: { __typename?: 'Money', currency: string, value: number } } | { __typename: 'Unlimited', type: LimitType, period: LimitPeriod }>, maxDeposit?: Array<{ __typename: 'MaxLimit', type: LimitType, period: LimitPeriod, value: { __typename?: 'Money', currency: string, value: number } } | { __typename: 'PlayerLimit', type: LimitType, period: LimitPeriod } | { __typename: 'Unlimited', type: LimitType, period: LimitPeriod }>, spending?: Array<{ __typename: 'MaxLimit', type: LimitType, period: LimitPeriod } | { __typename: 'PlayerLimit', type: LimitType, period: LimitPeriod, nextIncreaseFrom: string, nextPeriodStart: string, available: { __typename?: 'Money', currency: string, value: number }, value: { __typename?: 'Money', currency: string, value: number } } | { __typename: 'Unlimited', type: LimitType, period: LimitPeriod }>, maxSpending?: Array<{ __typename: 'MaxLimit', type: LimitType, period: LimitPeriod, value: { __typename?: 'Money', currency: string, value: number } } | { __typename: 'PlayerLimit', type: LimitType, period: LimitPeriod } | { __typename: 'Unlimited', type: LimitType, period: LimitPeriod }> } };

export type RequestPasswordResetMutationVariables = Exact<{
  input: RequestPasswordResetInput;
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset: { __typename?: 'RequestPasswordResetPayload', result: RequestPasswordResetResult } };

export type RequestVerificationCodeMutationVariables = Exact<{
  input: ResendCodeMutationInput;
}>;


export type RequestVerificationCodeMutation = { __typename?: 'Mutation', requestVerificationCode: { __typename?: 'ResendCodePayload', countryCode: string, nationalNumber: string } };

export type SelfExclusionMutationVariables = Exact<{
  input: SelfExclusionInput;
}>;


export type SelfExclusionMutation = { __typename?: 'Mutation', selfExclusion: { __typename?: 'SelfExclusionPayload', expires: string, type: SelfExclusionType, status: Status } };

export type SetScanVerifyUploadStatusMutationVariables = Exact<{
  input: SetScanVerifyUploadStatusInput;
}>;


export type SetScanVerifyUploadStatusMutation = { __typename?: 'Mutation', setScanVerifyUploadStatus: { __typename?: 'VerificationPayload', manualVerificationUrl?: string | null, name: VerificationPayloadName, status: VerificationPayloadStatus } };

export type StoredPaymentInstrumentsQueryVariables = Exact<{
  input: StoredPaymentInstrumentsInput;
}>;


export type StoredPaymentInstrumentsQuery = { __typename?: 'Query', storedPaymentInstruments: { __typename?: 'StoredPaymentInstruments', activePayInInstruments: Array<{ __typename?: 'StoredBankInstrument', internalId: string, paymentMethod: string, type: string } | { __typename?: 'StoredCardInstrument', cardholderName: string, expirationDate: string, expiryMonth?: number | null, expiryYear?: number | null, maskedCardNumber: string, internalId: string, paymentMethod: string, type: string } | { __typename?: 'StoredInstrumentPayPal', holderName: string, email: string, internalId: string, paymentMethod: string, type: string } | { __typename?: 'StoredInstrumentVenmo', venmoUserName: string, internalId: string, paymentMethod: string, type: string }> } };

export type TransactionsQueryVariables = Exact<{
  filter?: InputMaybe<ShopTransactionsFilterInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type TransactionsQuery = { __typename?: 'Query', transactionHistory: { __typename?: 'TransactionHistory', total: number, transactions: Array<{ __typename?: 'TransactionHistoryPayload', bookingDate: string, comment: string, id: string, orderId?: string | null, payOutId?: string | null, paymentIdentifier?: string | null, paymentMethod?: string | null, paymentProvider?: string | null, type: string, amount: { __typename?: 'Money', currency: string, value: number }, serviceFees?: { __typename?: 'Money', currency: string, value: number } | null, totalCharged?: { __typename?: 'Money', currency: string, value: number } | null }> } };

export type UploadIdentityDocumentMutationVariables = Exact<{
  input: UploadIdentityDocumentInput;
}>;


export type UploadIdentityDocumentMutation = { __typename?: 'Mutation', uploadIdentityDocument: { __typename?: 'UploadIdentityDocumentPayload', receivedAt: string } };

export type UserDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDataQuery = { __typename?: 'Query', player: { __typename?: 'PlayerPayload', address: any, dateOfBirth: string, id: string, isAutomaticAgeVerificationPending?: boolean | null, email: string, formattedPhoneNumber?: string | null, givenName: string, hasManualAgeVerification?: boolean | null, familyName: string, customerId: string, registrationDate: string, status: Status, isVerified?: boolean | null, shouldVerifyPhone?: boolean | null, phone: { __typename?: 'Phone', countryCode: string, number: string, status: VerificationPayloadStatus }, selfExclusion?: { __typename?: 'PlayerSelfExclusionPayload', expires: string, type: SelfExclusionType } | null, verifications: Array<{ __typename?: 'VerificationPayload', status: VerificationPayloadStatus, manualVerificationUrl?: string | null, name: VerificationPayloadName, dependsOn?: VerificationPayloadName | null }> } };

export type UserSecurityPhoneQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSecurityPhoneQuery = { __typename?: 'Query', player: { __typename?: 'PlayerPayload', status: Status, shouldVerifyPhone?: boolean | null, isVerified?: boolean | null, phone: { __typename?: 'Phone', countryCode: string, number: string, status: VerificationPayloadStatus } } };

export type UserStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type UserStatusQuery = { __typename?: 'Query', player: { __typename?: 'PlayerPayload', status: Status, selfExclusion?: { __typename?: 'PlayerSelfExclusionPayload', expires: string, type: SelfExclusionType } | null } };

export type UserVerificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserVerificationsQuery = { __typename?: 'Query', player: { __typename: 'PlayerPayload', verifications: Array<{ __typename: 'VerificationPayload', dependsOn?: VerificationPayloadName | null, manualVerificationUrl?: string | null, name: VerificationPayloadName, status: VerificationPayloadStatus }> } };

export type VerificationDataQueryVariables = Exact<{
  includePersonalData?: Scalars['Boolean']['input'];
}>;


export type VerificationDataQuery = { __typename?: 'Query', player: { __typename?: 'PlayerPayload', customerId: string, didAutomaticAgeVerificationFail?: boolean | null, didAutomaticAgeVerificationSucceed?: boolean | null, email?: string, familyName?: string, givenName?: string, hasAutomaticAgeVerificationStarted?: boolean | null, hasManualAgeVerification?: boolean | null, hasSendSafelyUpload?: boolean | null, idologyUrl?: string | null, isAutomaticAgeVerificationPending?: boolean | null, isIdologyPending?: boolean | null, isRegistered?: boolean | null, isVerified?: boolean | null, needsManualVerification?: boolean | null, shouldVerifyPhone?: boolean | null, status: Status, automaticAgeVerification?: { __typename?: 'VerificationPayload', dependsOn?: VerificationPayloadName | null, manualVerificationUrl?: string | null, name: VerificationPayloadName, status: VerificationPayloadStatus } | null, idologyVerification?: { __typename?: 'VerificationPayload', dependsOn?: VerificationPayloadName | null, manualVerificationUrl?: string | null, name: VerificationPayloadName, status: VerificationPayloadStatus } | null, phone: { __typename?: 'Phone', status: VerificationPayloadStatus }, verifications: Array<{ __typename?: 'VerificationPayload', dependsOn?: VerificationPayloadName | null, manualVerificationUrl?: string | null, name: VerificationPayloadName, status: VerificationPayloadStatus }> } };

export type VerifyPhoneMutationVariables = Exact<{
  input: VerifyPhoneInput;
}>;


export type VerifyPhoneMutation = { __typename?: 'Mutation', verifyPhone: { __typename?: 'VerifyPhonePayload', verified: boolean } };

export type BuyWithBalanceMutationVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
  locationProfilingId: Scalars['String']['input'];
  locationSessionId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ProductId']['input'];
  submitterIPAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type BuyWithBalanceMutation = { __typename?: 'Mutation', purchase: { __typename?: 'CancelledOrder', firstPayIn: boolean, orderId: string, reference: string, status: OrderStatus } | { __typename?: 'CreatedOrder', firstPayIn: boolean, orderId: string, reference: string, status: OrderStatus } | { __typename?: 'PaidOrder', firstPayIn: boolean, orderId: string, reference: string, status: OrderStatus } };

export type BuyWithTopUpMutationVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
  locationProfilingId: Scalars['String']['input'];
  locationSessionId?: InputMaybe<Scalars['String']['input']>;
  paymentData: PaymentDataInput;
  productId: Scalars['ProductId']['input'];
  submitterIPAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type BuyWithTopUpMutation = { __typename?: 'Mutation', purchase: { __typename?: 'CancelledOrder', firstPayIn: boolean, orderId: string, reference: string, status: OrderStatus } | { __typename?: 'CreatedOrder', firstPayIn: boolean, orderId: string, reference: string, status: OrderStatus } | { __typename?: 'PaidOrder', firstPayIn: boolean, orderId: string, reference: string, status: OrderStatus } };

export type CheckoutQueryVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
  productId: Scalars['ProductId']['input'];
}>;


export type CheckoutQuery = { __typename?: 'Query', checkout: { __typename?: 'CheckoutPayload', bonusCode?: string | null, state: CheckoutState, notification?: CheckoutNotification | null, accountBalance: { __typename?: 'Money', currency: string, value: number }, discount?: { __typename?: 'Money', currency: string, value: number } | null, restrictions?: { __typename?: 'Restrictions', geoCheck: GeoCheckStatus, playerCheck: PlayerCheckStatus, depositLimit?: { __typename?: 'ExceededLimit', period: LimitPeriod, type: LimitType, available: { __typename?: 'Money', currency: string, value: number }, value: { __typename?: 'Money', currency: string, value: number } } | null, spendingLimit?: { __typename?: 'ExceededLimit', period: LimitPeriod, type: LimitType, available: { __typename?: 'Money', currency: string, value: number }, value: { __typename?: 'Money', currency: string, value: number } } | null } | null, payment?: { __typename?: 'PayWithBalance', payWithBalance: boolean, accountBalance: { __typename?: 'Money', currency: string, value: number }, topUpAmount: { __typename?: 'Money', currency: string, value: number }, totalPrice: { __typename?: 'Money', currency: string, value: number } } | { __typename?: 'PayWithTopUp', paymentId: string, payWithBalance: boolean, initial: Array<{ __typename?: 'InitialPaymentInstrument', type: string, integrationType: string, methods: Array<string>, accountId: string, provider: string, providerUri?: string | null, venmoProfileId?: string | null, token: { __typename?: 'PaymentToken', expires: string, value: string } }>, stored: Array<{ __typename?: 'StoredPaymentInstrument', type: string, integrationType: string, method: string, holderName?: string | null, accountId: string, cardNumber?: string | null, expiryMonth?: number | null, expiryYear?: number | null, provider: string, requiresCvvConfirmation: boolean, token: { __typename?: 'PaymentToken', expires: string, value: string } }>, accountBalance: { __typename?: 'Money', currency: string, value: number }, topUpAmount: { __typename?: 'Money', currency: string, value: number }, totalPrice: { __typename?: 'Money', currency: string, value: number } } | null, product?: { __typename: 'LotteryProduct', name: string, numberOfDraws: number, numberOfPlays: number, subscription: boolean, price: { __typename?: 'Money', currency: string, value: number }, priceBreakdown: { __typename?: 'PriceBreakdown', libraryVersion: string, lotteryConfigVersion: string, numberOfDraws: number, numberOfPlays: number, priceListVersion: string, addOnChargePerPlaySlip: { __typename?: 'Money', currency: string, value: number }, addOnFeePerPlaySlip: { __typename?: 'Money', currency: string, value: number }, chargePerPlaySlip: { __typename?: 'Money', currency: string, value: number }, chargeTotal: { __typename?: 'Money', currency: string, value: number }, chargesForPlaySlipAddOns: Array<{ __typename?: 'ChargeForAddOn', name: string, baseCharge: { __typename?: 'Money', currency: string, value: number }, fee: { __typename?: 'Money', currency: string, value: number }, total: { __typename?: 'Money', currency: string, value: number } }>, chargesPerPlay: Array<{ __typename?: 'ChargeForPlay', extraInfo?: string | null, name: string, addOns: Array<{ __typename?: 'ChargeForAddOn', name: string, baseCharge: { __typename?: 'Money', currency: string, value: number }, fee: { __typename?: 'Money', currency: string, value: number }, total: { __typename?: 'Money', currency: string, value: number } }>, baseCharge: { __typename?: 'Money', currency: string, value: number }, fee: { __typename?: 'Money', currency: string, value: number } }>, feePerPlaySlip: { __typename?: 'Money', currency: string, value: number }, feeTotal: { __typename?: 'Money', currency: string, value: number }, grossTotal: { __typename?: 'Money', currency: string, value: number }, netTotal: { __typename?: 'Money', currency: string, value: number }, playChargePerPlaySlip: { __typename?: 'Money', currency: string, value: number }, playFeePerPlaySlip: { __typename?: 'Money', currency: string, value: number }, salesTax: { __typename?: 'Money', currency: string, value: number } }, subscriptionOptions?: { __typename?: 'SubscriptionOptions', drawsPerPurchase: number, type: SubscriptionType } | null } | { __typename: 'ScratchcardProduct', expiresAt: string, name: string, quantity: number, reservationId: string, price: { __typename?: 'Money', currency: string, value: number }, priceBreakdown: { __typename?: 'ScratchcardPriceBreakdown', quantity: number, chargeForOrder: { __typename?: 'Money', currency: string, value: number }, chargeTotal: { __typename?: 'Money', currency: string, value: number }, chargesForCards: { __typename?: 'Money', currency: string, value: number }, feeTotal: { __typename?: 'Money', currency: string, value: number }, feesForCards: { __typename?: 'Money', currency: string, value: number }, feeForOrder: { __typename?: 'Money', currency: string, value: number }, grossTotal: { __typename?: 'Money', currency: string, value: number }, netTotal: { __typename?: 'Money', currency: string, value: number }, salesTax: { __typename?: 'Money', currency: string, value: number } } } | null } };

export type OrderPollQueryVariables = Exact<{
  orderId: Scalars['OrderId']['input'];
}>;


export type OrderPollQuery = { __typename?: 'Query', order: { __typename?: 'CancelledOrder', cancelReasonType: CancelReasonType, status: OrderStatus } | { __typename?: 'CreatedOrder', status: OrderStatus } | { __typename?: 'PaidOrder', status: OrderStatus } };

export type OrderedTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderedTypeQuery = { __typename?: 'Query', orderedType: { __typename?: 'OrderedTypePayload', lottery: boolean, scratchcard: boolean, subscription: boolean } };

export type AddOnFragment = { __typename?: 'AddOn', mandatory: boolean, name: string, options: Array<string>, perPlay: boolean };

type Campaign_CampaignBadgePayload_Fragment = { __typename?: 'CampaignBadgePayload', bonusCode?: string | null, infoHeadline?: string | null, infoText?: string | null, title: string, type: BadgeType };

type Campaign_CampaignHeroHighlightPayload_Fragment = { __typename?: 'CampaignHeroHighlightPayload', pattern: HeroHighlightPattern, badge: { __typename?: 'CampaignHeroHighlightBadgePayload', bonusCode?: string | null, color: string, infoHeadline?: string | null, infoText?: string | null, placement: HeroHighlightStyle, title: string, subtitle: string } };

export type CampaignFragment = Campaign_CampaignBadgePayload_Fragment | Campaign_CampaignHeroHighlightPayload_Fragment;

export type CouponInfoFragment = { __typename?: 'BonusCodeInfoPayload', code: string, description: string, title: string, value: { __typename?: 'BonusValuePayload', amount: number, type: BonusValueEnum } };

export type CouponValidationResultFragment = { __typename?: 'BonusValidationResult', fulfillable: boolean, fulfilled: boolean, unfulfilledConditions: Array<string>, info: { __typename?: 'BonusCodeInfoPayload', code: string, description: string, title: string, value: { __typename?: 'BonusValuePayload', amount: number, type: BonusValueEnum } }, minTotalCharge?: { __typename?: 'Money', currency: string, value: number } | null };

export type ImagePropertiesFragment = { __typename?: 'ImagePropertiesPayload', blurHash: string, height: number, width: number };

export type LotteryTeaserFragment = { __typename: 'LotteryTeaserPayload', id: LotteryId, name: string, drawDate: string, closingDate: string, comingSoon: boolean, jackpotType: JackpotType, lotteryType: LotteryType, jackpotSize: { __typename: 'Money', currency: string, value: number }, campaign?: { __typename?: 'CampaignBadgePayload', bonusCode?: string | null, infoHeadline?: string | null, infoText?: string | null, title: string, type: BadgeType } | { __typename?: 'CampaignHeroHighlightPayload', pattern: HeroHighlightPattern, badge: { __typename?: 'CampaignHeroHighlightBadgePayload', bonusCode?: string | null, color: string, infoHeadline?: string | null, infoText?: string | null, placement: HeroHighlightStyle, title: string, subtitle: string } } | null, quickPick?: { __typename: 'QuickPickConfiguration', plays: number, addOns: Array<{ __typename: 'AddOnOutput', name: string, value: string }> } | null };

export type MoneyFragment = { __typename?: 'Money', currency: string, value: number };

export type PlayerLimitFragment = { __typename?: 'PlayerLimit', nextIncreaseFrom: string, nextPeriodStart: string, available: { __typename?: 'Money', currency: string, value: number }, value: { __typename?: 'Money', currency: string, value: number } };

export type PrizeTierCategoryFragment = { __typename?: 'PrizeTierCategory', group: string, name: string, categoryRequirements: Array<{ __typename?: 'AlwaysActivePrizeTierCategoryRequirements', type: PrizeTierCategoryRequirementsPayloadType } | { __typename: 'ByAddOnSelected', addOnName: string, type: PrizeTierCategoryRequirementsPayloadType } | { __typename: 'ByMultiplierDeselected', addOnName: string, type: PrizeTierCategoryRequirementsPayloadType } | { __typename: 'ByMultiplierSelected', addOnName: string, reference: string, value: number, type: PrizeTierCategoryRequirementsPayloadType } | { __typename: 'ByMultiplierValueMatched', addOnName: string, value: number, type: PrizeTierCategoryRequirementsPayloadType } | { __typename?: 'LotterySpecificPrizeTierCategoryRequirements', type: PrizeTierCategoryRequirementsPayloadType }>, prizeTiers: Array<{ __typename?: 'PrizeTier', jackpot: boolean, payoutInterval: PayoutInterval, tier: string, type: PrizeTierType, amount?: { __typename?: 'Money', currency: string, value: number } | null, requirements: { __typename?: 'LotterySpecificPrizeTierRequirements', type: PrizeTierRequirementsPayloadType } | { __typename?: 'LuckyLines', matchingLines: Array<number>, type: PrizeTierRequirementsPayloadType } | { __typename?: 'NumberLottery', type: PrizeTierRequirementsPayloadType, numberRequirements: Array<{ __typename?: 'NumberRequirement', amountOfCorrectNumbers: number, numbersReference: string }> } | { __typename?: 'PickLottery', type: PrizeTierRequirementsPayloadType, pickRequirements: Array<{ __typename?: 'PickRequirement', betType: string, ignoreFields: Array<string> }> } }> };

export type ScratchcardTeaserFragment = { __typename?: 'ScratchcardTeaserPayload', name: string, slug: string, amount?: { __typename?: 'Money', currency: string, value: number } | null, campaign?: { __typename?: 'CampaignBadgePayload', bonusCode?: string | null, infoHeadline?: string | null, infoText?: string | null, title: string, type: BadgeType } | { __typename?: 'CampaignHeroHighlightPayload', pattern: HeroHighlightPattern, badge: { __typename?: 'CampaignHeroHighlightBadgePayload', bonusCode?: string | null, color: string, infoHeadline?: string | null, infoText?: string | null, placement: HeroHighlightStyle, title: string, subtitle: string } } | null, price?: { __typename?: 'Money', currency: string, value: number } | null, visualParameters?: { __typename?: 'ScratchcardVisualParameters', primaryColor?: string | null, secondaryColor?: string | null, teaserImageUrl?: string | null, titleColor: string } | null };

export type ApplyBonusCodeMutationVariables = Exact<{
  bonusCode: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type ApplyBonusCodeMutation = { __typename?: 'Mutation', applyBonusCode: { __typename?: 'BonusValidationResult', fulfillable: boolean, fulfilled: boolean, unfulfilledConditions: Array<string>, info: { __typename?: 'BonusCodeInfoPayload', code: string, description: string, title: string, value: { __typename?: 'BonusValuePayload', amount: number, type: BonusValueEnum } }, minTotalCharge?: { __typename?: 'Money', currency: string, value: number } | null } };

export type BonusCodeInfoQueryVariables = Exact<{
  bonusCode: Scalars['String']['input'];
}>;


export type BonusCodeInfoQuery = { __typename?: 'Query', bonusCodeInfo: { __typename?: 'BonusCodeInfoPayload', code: string, description: string, title: string, value: { __typename?: 'BonusValuePayload', amount: number, type: BonusValueEnum } } };

export type CheckBonusCodeForPlaySlipQueryVariables = Exact<{
  input: BonusCodeValidationInput;
}>;


export type CheckBonusCodeForPlaySlipQuery = { __typename?: 'Query', checkBonusCodeForPlaySlip: { __typename?: 'BonusValidationResult', fulfillable: boolean, fulfilled: boolean, unfulfilledConditions: Array<string>, info: { __typename?: 'BonusCodeInfoPayload', code: string, description: string, title: string, value: { __typename?: 'BonusValuePayload', amount: number, type: BonusValueEnum } }, minTotalCharge?: { __typename?: 'Money', currency: string, value: number } | null } };

export type DefaultTeasersQueryVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
  productType: KnownProductType;
}>;


export type DefaultTeasersQuery = { __typename?: 'Query', defaultTeasers: { __typename?: 'DefaultTeasersPayload', id: string, productType: KnownProductType, teasers: Array<{ __typename: 'LotteryTeaserPayload', id: LotteryId, name: string, drawDate: string, closingDate: string, comingSoon: boolean, jackpotType: JackpotType, lotteryType: LotteryType, jackpotSize: { __typename: 'Money', currency: string, value: number }, campaign?: { __typename?: 'CampaignBadgePayload', bonusCode?: string | null, infoHeadline?: string | null, infoText?: string | null, title: string, type: BadgeType } | { __typename?: 'CampaignHeroHighlightPayload', pattern: HeroHighlightPattern, badge: { __typename?: 'CampaignHeroHighlightBadgePayload', bonusCode?: string | null, color: string, infoHeadline?: string | null, infoText?: string | null, placement: HeroHighlightStyle, title: string, subtitle: string } } | null, quickPick?: { __typename: 'QuickPickConfiguration', plays: number, addOns: Array<{ __typename: 'AddOnOutput', name: string, value: string }> } | null } | { __typename?: 'ScratchcardTeaserPayload', name: string, slug: string, amount?: { __typename?: 'Money', currency: string, value: number } | null, campaign?: { __typename?: 'CampaignBadgePayload', bonusCode?: string | null, infoHeadline?: string | null, infoText?: string | null, title: string, type: BadgeType } | { __typename?: 'CampaignHeroHighlightPayload', pattern: HeroHighlightPattern, badge: { __typename?: 'CampaignHeroHighlightBadgePayload', bonusCode?: string | null, color: string, infoHeadline?: string | null, infoText?: string | null, placement: HeroHighlightStyle, title: string, subtitle: string } } | null, price?: { __typename?: 'Money', currency: string, value: number } | null, visualParameters?: { __typename?: 'ScratchcardVisualParameters', primaryColor?: string | null, secondaryColor?: string | null, teaserImageUrl?: string | null, titleColor: string } | null }> } };

export type RedeemMoneyMutationVariables = Exact<{
  input: MoneyBackInput;
}>;


export type RedeemMoneyMutation = { __typename?: 'Mutation', requestMoneyBack: { __typename?: 'MoneyBackPayload', code: string, id: string, productId: string, status: MoneyBackStatus, price: { __typename?: 'Money', currency: string, value: number } } };

export type RemoveBonusCodeMutationVariables = Exact<{
  bonusCode: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type RemoveBonusCodeMutation = { __typename?: 'Mutation', removeBonusCode: { __typename?: 'BonusCodeRemovalPayload', bonusCode: string } };

export type TeasersQueryVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
}>;


export type TeasersQuery = { __typename?: 'Query', teasers: { __typename?: 'TeasersPayload', id: string, teasers: Array<{ __typename: 'LotteryTeaserPayload', id: LotteryId, name: string, drawDate: string, closingDate: string, comingSoon: boolean, jackpotType: JackpotType, lotteryType: LotteryType, jackpotSize: { __typename: 'Money', currency: string, value: number }, campaign?: { __typename?: 'CampaignBadgePayload', bonusCode?: string | null, infoHeadline?: string | null, infoText?: string | null, title: string, type: BadgeType } | { __typename?: 'CampaignHeroHighlightPayload', pattern: HeroHighlightPattern, badge: { __typename?: 'CampaignHeroHighlightBadgePayload', bonusCode?: string | null, color: string, infoHeadline?: string | null, infoText?: string | null, placement: HeroHighlightStyle, title: string, subtitle: string } } | null, quickPick?: { __typename: 'QuickPickConfiguration', plays: number, addOns: Array<{ __typename: 'AddOnOutput', name: string, value: string }> } | null } | { __typename?: 'ScratchcardTeaserPayload', name: string, slug: string, price?: { __typename?: 'Money', currency: string, value: number } | null, amount?: { __typename?: 'Money', currency: string, value: number } | null, campaign?: { __typename?: 'CampaignBadgePayload', bonusCode?: string | null, infoHeadline?: string | null, infoText?: string | null, title: string, type: BadgeType } | { __typename?: 'CampaignHeroHighlightPayload', pattern: HeroHighlightPattern, badge: { __typename?: 'CampaignHeroHighlightBadgePayload', bonusCode?: string | null, color: string, infoHeadline?: string | null, infoText?: string | null, placement: HeroHighlightStyle, title: string, subtitle: string } } | null, visualParameters?: { __typename?: 'ScratchcardVisualParameters', primaryColor?: string | null, secondaryColor?: string | null, teaserImageUrl?: string | null, titleColor: string } | null }> } };

export type CookiesQueryVariables = Exact<{ [key: string]: never; }>;


export type CookiesQuery = { __typename?: 'Query', cookies?: string | null };

export type CancelSubscriptionMutationVariables = Exact<{
  code: Scalars['SubscriptionCode']['input'];
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription: { __typename?: 'SubscriptionInfo', status: SubscriptionStatus } };

export type LotteriesQueryVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
}>;


export type LotteriesQuery = { __typename?: 'Query', lotteries: Array<{ __typename: 'LotteryPayload', id: LotteryId, currentConfig: { __typename: 'VersionedConfig', jackpotType: JackpotType } }> };

export type LotteryQueryVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
  lotteryId: LotteryId;
}>;


export type LotteryQuery = { __typename?: 'Query', lottery: { __typename?: 'LotteryPayload', id: LotteryId, properties: Array<LotteryProperty>, currentConfig: { __typename?: 'VersionedConfig', allowedPlays: Array<number>, isLockoutLottery: boolean, numberOfDraws: Array<number>, subscriptionsAllowed: boolean, type: LotteryType, version: string, addOns: Array<{ __typename?: 'AddOn', mandatory: boolean, name: string, options: Array<string>, perPlay: boolean }>, afterPurchaseAddOns: Array<{ __typename?: 'AddOn', mandatory: boolean, name: string, options: Array<string>, perPlay: boolean }>, prepaidSubscription?: { __typename?: 'PrepaidSubscriptionsConfig', customDrawsMax: number, customDrawsMin: number, selectableDrawsOptions: Array<number> } | null, numbers: Array<{ __typename?: 'NumbersConfig', max: number, min: number, name: string, selectableMax: number, ignoredForAddOns: Array<{ __typename?: 'AddOnWithValue', name: string, value: string }> }>, prizeTierCategories: Array<{ __typename?: 'PrizeTierCategory', group: string, name: string, categoryRequirements: Array<{ __typename?: 'AlwaysActivePrizeTierCategoryRequirements', type: PrizeTierCategoryRequirementsPayloadType } | { __typename: 'ByAddOnSelected', addOnName: string, type: PrizeTierCategoryRequirementsPayloadType } | { __typename: 'ByMultiplierDeselected', addOnName: string, type: PrizeTierCategoryRequirementsPayloadType } | { __typename: 'ByMultiplierSelected', addOnName: string, reference: string, value: number, type: PrizeTierCategoryRequirementsPayloadType } | { __typename: 'ByMultiplierValueMatched', addOnName: string, value: number, type: PrizeTierCategoryRequirementsPayloadType } | { __typename?: 'LotterySpecificPrizeTierCategoryRequirements', type: PrizeTierCategoryRequirementsPayloadType }>, prizeTiers: Array<{ __typename?: 'PrizeTier', jackpot: boolean, payoutInterval: PayoutInterval, tier: string, type: PrizeTierType, amount?: { __typename?: 'Money', currency: string, value: number } | null, requirements: { __typename?: 'LotterySpecificPrizeTierRequirements', type: PrizeTierRequirementsPayloadType } | { __typename?: 'LuckyLines', matchingLines: Array<number>, type: PrizeTierRequirementsPayloadType } | { __typename?: 'NumberLottery', type: PrizeTierRequirementsPayloadType, numberRequirements: Array<{ __typename?: 'NumberRequirement', amountOfCorrectNumbers: number, numbersReference: string }> } | { __typename?: 'PickLottery', type: PrizeTierRequirementsPayloadType, pickRequirements: Array<{ __typename?: 'PickRequirement', betType: string, ignoreFields: Array<string> }> } }> }>, quickPick?: { __typename?: 'VersionedConfigQuickpicks', plays: number, validQuickPickPlays: Array<number>, addOns: Array<{ __typename?: 'AddOnOutput', name: string, value: string }> } | null, stakes: Array<{ __typename?: 'Stake', price: string }> }, priceList: { __typename?: 'PriceListPayload', lotteryId: LotteryId, salesTaxStrategy: SalesTaxStrategy, version: string, charges: Array<{ __typename?: 'FixedCharge', id: string, perPlay: boolean, type: PriceType, value: { __typename?: 'Money', currency: string, value: number } } | { __typename?: 'MultiplyingCharge', id: string, perPlay: boolean, type: PriceType, multiplier: number }>, fees: Array<{ __typename?: 'FixedFee', id: string, perPlay: boolean, type: PriceType, value: { __typename?: 'Money', currency: string, value: number } } | { __typename?: 'MultiplyingFee', id: string, perPlay: boolean, type: PriceType, multiplier: number }> } } };

export type LotteryTeasersQueryVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
}>;


export type LotteryTeasersQuery = { __typename?: 'Query', lotteryTeasers: Array<{ __typename: 'LotteryTeaserPayload', id: LotteryId, name: string, drawDate: string, closingDate: string, comingSoon: boolean, jackpotType: JackpotType, lotteryType: LotteryType, jackpotSize: { __typename: 'Money', currency: string, value: number }, campaign?: { __typename?: 'CampaignBadgePayload', bonusCode?: string | null, infoHeadline?: string | null, infoText?: string | null, title: string, type: BadgeType } | { __typename?: 'CampaignHeroHighlightPayload', pattern: HeroHighlightPattern, badge: { __typename?: 'CampaignHeroHighlightBadgePayload', bonusCode?: string | null, color: string, infoHeadline?: string | null, infoText?: string | null, placement: HeroHighlightStyle, title: string, subtitle: string } } | null, quickPick?: { __typename: 'QuickPickConfiguration', plays: number, addOns: Array<{ __typename: 'AddOnOutput', name: string, value: string }> } | null }> };

export type NextDrawQueryVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
  lotteryId: LotteryId;
}>;


export type NextDrawQuery = { __typename?: 'Query', nextDraw?: { __typename?: 'DrawPayload', drawDate: string, jackpots: Array<{ __typename?: 'Jackpot', value: { __typename?: 'Money', currency: string, value: number } }> } | null };

export type OrderTypeQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type OrderTypeQuery = { __typename?: 'Query', orderType: { __typename?: 'SingleOrderMultipleLines', type: PlaySlipType } };

export type PlaySlipOrdersQueryVariables = Exact<{
  filter: PlaySlipOrdersFilterInput;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type PlaySlipOrdersQuery = { __typename?: 'Query', playSlipOrders: { __typename?: 'PlaySlipOrdersPayload', count: number, playSlipOrders: Array<{ __typename?: 'ActivePlaySlipOrder', hasWinnings: boolean, id: string, orderId: string, lastDrawDate: string, licensedTerritory: string, lotteryId: LotteryId, nextDrawDate: string, numberOfPlays: number, selectedAddOns: Array<string>, status: PlaySlipOrderStatus, totalWinAmount: { __typename?: 'Money', currency: string, value: number }, subscriptionInfo?: { __typename?: 'SubscriptionInfo', status: SubscriptionStatus } | null } | { __typename?: 'ClosedPlaySlipOrder', hasWinnings: boolean, id: string, orderId: string, lastDrawDate: string, licensedTerritory: string, lotteryId: LotteryId, nextDrawDate: string, numberOfPlays: number, selectedAddOns: Array<string>, status: PlaySlipOrderStatus, totalWinAmount: { __typename?: 'Money', currency: string, value: number }, subscriptionInfo?: { __typename?: 'SubscriptionInfo', status: SubscriptionStatus } | null } | { __typename?: 'PendingPlaySlipOrder', id: string, orderId: string, lastDrawDate: string, licensedTerritory: string, lotteryId: LotteryId, nextDrawDate: string, numberOfPlays: number, selectedAddOns: Array<string>, status: PlaySlipOrderStatus, subscriptionInfo?: { __typename?: 'SubscriptionInfo', status: SubscriptionStatus } | null }> } };

export type RecommendationsQueryVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
  purchasedProductType: KnownProductType;
  purchasedProductSubtype: Scalars['String']['input'];
}>;


export type RecommendationsQuery = { __typename?: 'Query', recommendations: { __typename?: 'TeasersPayload', id: string, teasers: Array<{ __typename?: 'LotteryTeaserPayload', id: LotteryId, name: string, closingDate: string, drawDate: string, jackpotType: JackpotType, lotteryType: LotteryType, comingSoon: boolean, jackpotSize: { __typename?: 'Money', value: number, currency: string }, campaign?: { __typename?: 'CampaignBadgePayload', bonusCode?: string | null, infoHeadline?: string | null, infoText?: string | null, title: string, type: BadgeType } | { __typename?: 'CampaignHeroHighlightPayload', pattern: HeroHighlightPattern, badge: { __typename?: 'CampaignHeroHighlightBadgePayload', bonusCode?: string | null, color: string, infoHeadline?: string | null, infoText?: string | null, placement: HeroHighlightStyle, title: string, subtitle: string } } | null, quickPick?: { __typename?: 'QuickPickConfiguration', plays: number } | null } | { __typename?: 'ScratchcardTeaserPayload', slug: string, name: string, amount?: { __typename?: 'Money', value: number, currency: string } | null, campaign?: { __typename?: 'CampaignBadgePayload', bonusCode?: string | null, infoHeadline?: string | null, infoText?: string | null, title: string, type: BadgeType } | { __typename?: 'CampaignHeroHighlightPayload', pattern: HeroHighlightPattern, badge: { __typename?: 'CampaignHeroHighlightBadgePayload', bonusCode?: string | null, color: string, infoHeadline?: string | null, infoText?: string | null, placement: HeroHighlightStyle, title: string, subtitle: string } } | null, visualParameters?: { __typename?: 'ScratchcardVisualParameters', titleColor: string, primaryColor?: string | null, secondaryColor?: string | null, teaserImageUrl?: string | null } | null }> } };

export type ReplayPlaySlipMutationVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
  playSlipOrderId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReplayPlaySlipMutation = { __typename?: 'Mutation', replayPlaySlip: { __typename?: 'PlaySlipStored', id: string } };

export type ScheduledDrawsQueryVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  lotteryId: LotteryId;
}>;


export type ScheduledDrawsQuery = { __typename?: 'Query', scheduledDraws: Array<{ __typename?: 'DrawPayload', closingDate: string, drawDate: string, lotteryConfig: { __typename?: 'LotteryPayload', currentConfig: { __typename?: 'VersionedConfig', type: LotteryType } }, jackpots: Array<{ __typename?: 'Jackpot', value: { __typename?: 'Money', currency: string, value: number } }> }> };

export type ScratchcardOrdersQueryVariables = Exact<{
  filter: ScratchcardsFilterInput;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type ScratchcardOrdersQuery = { __typename?: 'Query', scratchcardOrders: { __typename?: 'ScratchcardOrdersPayload', count: number, scratchcardOrders: Array<{ __typename?: 'ScratchcardOrderPayload', gameName: string, gameSlug: string, orderId: string, quantity: number, quantityActive: number, quantityPast: number, state: ScratchcardState, titleColor: string, winnings?: { __typename?: 'Money', currency: string, value: number } | null }> } };

export type SingleOrderMultipleLinesQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
  limitPlays?: InputMaybe<Scalars['Int']['input']>;
  offsetPlays?: InputMaybe<Scalars['Int']['input']>;
  groupOfPlays?: InputMaybe<Scalars['DrawnNumbersGroup']['input']>;
}>;


export type SingleOrderMultipleLinesQuery = { __typename?: 'Query', singleOrderMultipleLines: { __typename?: 'SingleOrderMultipleLines', id: string, nextDrawDate?: string | null, orderedIn: string, orderId: string, state: string, type: PlaySlipType, lottery: { __typename?: 'LotteryPayload', active: boolean, id: LotteryId, licensedTerritory: string, currentConfig: { __typename?: 'VersionedConfig', type: LotteryType, addOns: Array<{ __typename?: 'AddOn', name: string, perPlay: boolean }>, afterPurchaseAddOns: Array<{ __typename?: 'AddOn', name: string, perPlay: boolean }>, numbers: Array<{ __typename?: 'NumbersConfig', name: string, selectableMax: number }> } }, price: { __typename?: 'Money', currency: string, value: number }, results: Array<{ __typename?: 'ResultsMultipleLines', drawDate: string, hasWinnings: boolean, hasMultipleDrawsOnDay: boolean, label: DrawLabel, ticketScanUrlsExpirationDate: string, totalNumberOfFreePlays?: number | null, lotteryResults: Array<{ __typename?: 'LotteryResultsMultipleLines', countOfPlays: number, group: string, drawnNumbers?: { __typename?: 'DrawnNumbersMultipleLines', numbers: Array<{ __typename?: 'Numbers', modifies?: string | null, name: string, values: Array<number> }> } | null, plays: Array<{ __typename?: 'PlaysMultipleLines', serialNumber: string, state: PlaySlipStatus, addOns: Array<{ __typename?: 'AddOnOutput', name: string, value: string }>, addOnValues: Array<{ __typename?: 'AddOnOutput', name: string, value: string }>, winnings: { __typename?: 'WinningMultipleLines', numberOfFreePlays?: number | null, amount?: { __typename?: 'Money', currency: string, value: number } | null }, fields: Array<{ __typename?: 'FieldWithMatches', name: string, selected: Array<number>, numbers: Array<{ __typename?: 'NumberWithMatch', matching: boolean, value: number }> }> }> }>, ticketScans: Array<{ __typename?: 'TicketScansMultipleLines', serialNumber: string, scans: Array<{ __typename?: 'TicketScanPayload', url: string, imageProperties: { __typename?: 'ImagePropertiesPayload', blurHash: string, height: number, width: number } }> }>, totalWinnings?: { __typename?: 'Money', currency: string, value: number } | null }> } };

export type SubscriptionOrderMultipleLinesQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
  limitPlays?: InputMaybe<Scalars['Int']['input']>;
  offsetPlays?: InputMaybe<Scalars['Int']['input']>;
  limitDrawResults?: InputMaybe<Scalars['Int']['input']>;
  offsetDrawResults?: InputMaybe<Scalars['Int']['input']>;
  drawDateOfPlays?: InputMaybe<Scalars['DateTime']['input']>;
  groupOfPlays?: InputMaybe<Scalars['DrawnNumbersGroup']['input']>;
}>;


export type SubscriptionOrderMultipleLinesQuery = { __typename?: 'Query', subscriptionOrderMultipleLines: { __typename?: 'SubscriptionOrderMultipleLinesPayload', id: string, lastDrawDate: string, latestPlaySlipOrderId: string, nextDrawDate?: string | null, orderedIn: string, status: SubscriptionStatus, subscriptionCode: string, totalDrawResults: number, type: PlaySlipType, lottery: { __typename?: 'LotteryPayload', active: boolean, id: LotteryId, licensedTerritory: string, currentConfig: { __typename?: 'VersionedConfig', type: LotteryType, addOns: Array<{ __typename?: 'AddOn', name: string, perPlay: boolean }>, afterPurchaseAddOns: Array<{ __typename?: 'AddOn', name: string, perPlay: boolean }>, numbers: Array<{ __typename?: 'NumbersConfig', name: string, selectableMax: number }> } }, price: { __typename?: 'Money', currency: string, value: number }, results: Array<{ __typename?: 'ResultsMultipleLines', drawDate: string, hasWinnings: boolean, hasMultipleDrawsOnDay: boolean, label: DrawLabel, ticketScanUrlsExpirationDate: string, totalNumberOfFreePlays?: number | null, lotteryResults: Array<{ __typename?: 'LotteryResultsMultipleLines', countOfPlays: number, group: string, drawnNumbers?: { __typename?: 'DrawnNumbersMultipleLines', numbers: Array<{ __typename?: 'Numbers', modifies?: string | null, name: string, values: Array<number> }> } | null, plays: Array<{ __typename?: 'PlaysMultipleLines', serialNumber: string, state: PlaySlipStatus, addOns: Array<{ __typename?: 'AddOnOutput', name: string, value: string }>, addOnValues: Array<{ __typename?: 'AddOnOutput', name: string, value: string }>, winnings: { __typename?: 'WinningMultipleLines', numberOfFreePlays?: number | null, amount?: { __typename?: 'Money', currency: string, value: number } | null }, fields: Array<{ __typename?: 'FieldWithMatches', name: string, numbers: Array<{ __typename?: 'NumberWithMatch', matching: boolean, value: number }> }> }> }>, ticketScans: Array<{ __typename?: 'TicketScansMultipleLines', serialNumber: string, scans: Array<{ __typename?: 'TicketScanPayload', url: string, imageProperties: { __typename?: 'ImagePropertiesPayload', blurHash: string, height: number, width: number } }> }>, totalWinnings?: { __typename?: 'Money', currency: string, value: number } | null }>, prepaidOptions?: { __typename?: 'PrepaidOptions', participatedDraws: number, remainingDraws: number, totalDraws: number } | null } };

export type SubscriptionsMultipleLinesQueryVariables = Exact<{
  filter: SubscriptionsFilterInput;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type SubscriptionsMultipleLinesQuery = { __typename?: 'Query', subscriptionsMultipleLines: { __typename?: 'SubscriptionsMultipleLines', count: number, subscriptions: Array<{ __typename?: 'SubscriptionMultipleLines', code: string, id: string, lastDrawDate: string, latestOrderId: string, licensedTerritory: string, latestPlaySlipOrderId?: string | null, lotteryId: LotteryId, nextDrawDate?: string | null, numberOfPlays: number, selectedAddOns: Array<string>, status: SubscriptionStatus, prepaidOptions?: { __typename?: 'PrepaidOptions', participatedDraws: number, remainingDraws: number, totalDraws: number } | null }> } };

export type ActiveAnnouncementQueryVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
}>;


export type ActiveAnnouncementQuery = { __typename?: 'Query', activeAnnouncement?: { __typename?: 'AnnouncementQueryResponse', id: string, title: string, description: string, changeDate: string, active: boolean } | null };

export type MarketingPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketingPreferencesQuery = { __typename?: 'Query', marketingPreferences: { __typename?: 'MarketingPreferencesPayload', channels: Array<{ __typename?: 'MarketingChannelPreferencesPayload', channel: MarketingChannel, activated: boolean, verified: boolean }> } };

export type SetMarketingChannelPreferencesMutationVariables = Exact<{
  input: MarketingChannelPreferenceMutationInput;
}>;


export type SetMarketingChannelPreferencesMutation = { __typename?: 'Mutation', setMarketingChannelPreferences: { __typename?: 'MarketingChannelPreferencesPayload', activated: boolean, channel: MarketingChannel } };

export type AddFundsConfigQueryVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
  input?: InputMaybe<AddFundsInput>;
}>;


export type AddFundsConfigQuery = { __typename?: 'Query', addFundsConfig: { __typename?: 'AddFundsConfigPayload', productId?: string | null, withCustomAmount: boolean, fees: { __typename?: 'AddFundsFees', dynamicFee: number, staticFee: { __typename?: 'Money', currency: string, value: number } }, limits: { __typename?: 'AddFundsLimits', maxPayInAmount: { __typename?: 'Money', currency: string, value: number }, minPayInAmount: { __typename?: 'Money', currency: string, value: number } }, payment: { __typename?: 'AddFundsPayment', paymentId: string, initial: Array<{ __typename?: 'InitialPaymentInstrument', accountId: string, integrationType: string, methods: Array<string>, provider: string, providerUri?: string | null, type: string, venmoProfileId?: string | null, token: { __typename?: 'PaymentToken', expires: string, value: string } }>, stored: Array<{ __typename?: 'StoredPaymentInstrument', accountId: string, cardNumber?: string | null, expiryMonth?: number | null, expiryYear?: number | null, holderName?: string | null, integrationType: string, lastUsed: string, method: string, provider: string, requiresCvvConfirmation: boolean, type: string, token: { __typename?: 'PaymentToken', expires: string, value: string } }> }, pricePoints: Array<{ __typename?: 'PricePoint', isMostPopular: boolean, withinFundingLimit: boolean, amount: { __typename?: 'Money', currency: string, value: number }, fees: { __typename?: 'Money', currency: string, value: number }, totalAmount: { __typename?: 'Money', currency: string, value: number } }> } };

export type AddFundsStatusQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AddFundsStatusQuery = { __typename?: 'Query', addFundsStatus: { __typename?: 'AddFundsStatusPayload', id: string, status: AddFundsState } };

export type AddFundsMutationVariables = Exact<{
  input: AddFundsMutationInput;
}>;


export type AddFundsMutation = { __typename?: 'Mutation', addFunds: { __typename?: 'AddFundsStatusPayload', id: string, isFirstPurchase: boolean, status: AddFundsState } };

export type ApplePayMerchantValidationQueryVariables = Exact<{
  input: ApplePayMerchantValidationInput;
}>;


export type ApplePayMerchantValidationQuery = { __typename?: 'Query', applePayMerchantValidation: { __typename?: 'ApplePayMerchantValidationPayload', encodedPaymentSession: string } };

export type PaymentMethodsQueryVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
}>;


export type PaymentMethodsQuery = { __typename?: 'Query', paymentMethods: Array<{ __typename?: 'PaymentMethod', allowsSubscriptionPurchase: boolean, name: string, type: string }> };

export type CheckRoutingNumberQueryVariables = Exact<{
  routingNumber: Scalars['String']['input'];
}>;


export type CheckRoutingNumberQuery = { __typename?: 'Query', checkRoutingNumber: { __typename?: 'CheckRoutingNumberPayload', bankName?: string | null, isKnown: boolean } };

export type PayOutAccountsQueryVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
}>;


export type PayOutAccountsQuery = { __typename?: 'Query', payOutAccounts: { __typename?: 'PayOutOptions', holderName: string, accounts: Array<{ __typename?: 'PayOutAccountBank', routingNumber: string, accountNumber: string, holderName: string, id: string, type: PayOutAccountType } | { __typename?: 'PayOutAccountPayPal', payPalPayerEmail: string, holderName: string, id: string, type: PayOutAccountType }>, minPayableBalance: { __typename?: 'Money', currency: string, value: number }, maxPayableBalance: { __typename?: 'Money', currency: string, value: number } } };

export type PayOutToBankAccountMutationVariables = Exact<{
  input: BankPayOutInput;
}>;


export type PayOutToBankAccountMutation = { __typename?: 'Mutation', payOutToBankAccount: { __typename?: 'PayOutPayload', id: string, state: PayOutState, amount: { __typename?: 'Money', currency: string, value: number } } };

export type PayOutToSavedAccountMutationVariables = Exact<{
  input: SavedPayOutInput;
}>;


export type PayOutToSavedAccountMutation = { __typename?: 'Mutation', payOutToSavedAccount: { __typename?: 'PayOutPayload', id: string, state: PayOutState, amount: { __typename?: 'Money', currency: string, value: number } } };

export type StorePlaySlipMutationVariables = Exact<{
  input: PlaySlipInput;
}>;


export type StorePlaySlipMutation = { __typename?: 'Mutation', storePlaySlip: { __typename?: 'PlaySlipStored', id: string } };

export type ValidatePlaySlipQueryVariables = Exact<{
  input: PlaySlipInput;
}>;


export type ValidatePlaySlipQuery = { __typename?: 'Query', validatePlaySlip: { __typename?: 'PlaySlipValidationPayload', success: boolean } };

export type CheckActivePendingQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckActivePendingQuery = { __typename?: 'Query', playSlipHistory: { __typename?: 'PlaySlipHistoryPayload', active: Array<{ __typename?: 'ActivePlaySlip', id: string }>, pending: Array<{ __typename?: 'PendingPlaySlip', id: string }> } };

export type PlayerSignupFinishedQueryVariables = Exact<{ [key: string]: never; }>;


export type PlayerSignupFinishedQuery = { __typename?: 'Query', playerSignupFinished: { __typename?: 'SignupFinishedPayload', exists: boolean } };

export type VerifyEmailMutationVariables = Exact<{
  input: VerifyEmailInput;
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail: { __typename?: 'VerifyEmailPayload', success: boolean } };

export type DrawResultsQueryVariables = Exact<{
  filter?: InputMaybe<DrawResultsFilterInput>;
  licensedTerritory: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type DrawResultsQuery = { __typename?: 'Query', drawListByDay: { __typename?: 'DrawHistoryByDayPayload', count: number, timeZone: string, days: Array<{ __typename?: 'DrawsByDayPayload', date: string, draws: Array<{ __typename?: 'ReformattedDrawPayload', drawDate: string, hasMultipleDrawsOnDay: boolean, id: string, label: DrawLabel, lotteryId: LotteryId, drawnNumbers: Array<{ __typename?: 'ReformattedDrawnNumbers', name: string, numbers: Array<{ __typename?: 'Numbers', modifies?: string | null, name: string, values: Array<number> }> }>, lotteryConfig: { __typename?: 'LotteryPayload', licensedTerritory: string, currentConfig: { __typename?: 'VersionedConfig', addOns: Array<{ __typename?: 'AddOn', name: string, perPlay: boolean }> } } }> }> } };

export type ResultDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ResultDetailsQuery = { __typename?: 'Query', drawDetail: { __typename?: 'FinishedDrawPayload', addOns: Array<string>, drawDate: string, hasMultipleDrawsOnDay: boolean, label: DrawLabel, lotteryId: LotteryId, drawnNumbers: Array<{ __typename?: 'DrawnNumbersPayload', group: string, numbers: Array<{ __typename?: 'Numbers', modifies?: string | null, name: string, values: Array<number> }> }>, lotteryConfig: { __typename?: 'LotteryPayload', timeZone: string, currentConfig: { __typename?: 'VersionedConfig', combinedTierTable: boolean, hasNumberOfWinners: boolean, type: LotteryType, addOns: Array<{ __typename?: 'AddOn', mandatory: boolean, name: string, options: Array<string>, perPlay: boolean }>, afterPurchaseAddOns: Array<{ __typename?: 'AddOn', mandatory: boolean, name: string, options: Array<string>, perPlay: boolean }>, prizeTierCategories: Array<{ __typename?: 'PrizeTierCategory', group: string, name: string, categoryRequirements: Array<{ __typename?: 'AlwaysActivePrizeTierCategoryRequirements', type: PrizeTierCategoryRequirementsPayloadType } | { __typename: 'ByAddOnSelected', addOnName: string, type: PrizeTierCategoryRequirementsPayloadType } | { __typename: 'ByMultiplierDeselected', addOnName: string, type: PrizeTierCategoryRequirementsPayloadType } | { __typename: 'ByMultiplierSelected', addOnName: string, reference: string, value: number, type: PrizeTierCategoryRequirementsPayloadType } | { __typename: 'ByMultiplierValueMatched', addOnName: string, value: number, type: PrizeTierCategoryRequirementsPayloadType } | { __typename?: 'LotterySpecificPrizeTierCategoryRequirements', type: PrizeTierCategoryRequirementsPayloadType }>, prizeTiers: Array<{ __typename?: 'PrizeTier', jackpot: boolean, payoutInterval: PayoutInterval, tier: string, type: PrizeTierType, amount?: { __typename?: 'Money', currency: string, value: number } | null, requirements: { __typename?: 'LotterySpecificPrizeTierRequirements', type: PrizeTierRequirementsPayloadType } | { __typename?: 'LuckyLines', matchingLines: Array<number>, type: PrizeTierRequirementsPayloadType } | { __typename?: 'NumberLottery', type: PrizeTierRequirementsPayloadType, numberRequirements: Array<{ __typename?: 'NumberRequirement', amountOfCorrectNumbers: number, numbersReference: string }> } | { __typename?: 'PickLottery', type: PrizeTierRequirementsPayloadType, pickRequirements: Array<{ __typename?: 'PickRequirement', betType: string, ignoreFields: Array<string> }> } }> }> } }, prizeCategories: Array<{ __typename?: 'PrizeCategory', group: string, name: string, prizes: Array<{ __typename?: 'FreeTicket', tier: string, type: PrizeTierType, winners: number, prize?: { __typename?: 'Money', currency: string, value: number } | null } | { __typename?: 'Prize', tier: string, type: PrizeTierType, winners: number, prize: { __typename?: 'Money', currency: string, value: number } }> }> } };

export type CheckScratchcardOrderQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type CheckScratchcardOrderQuery = { __typename?: 'Query', scratchcardOrder: { __typename?: 'ScratchcardOrderDetail', orderId: string } };

export type ReserveScratchcardsMutationVariables = Exact<{
  input: ReserveScratchcardsInput;
}>;


export type ReserveScratchcardsMutation = { __typename?: 'Mutation', reserveScratchcards: { __typename?: 'ScratchcardReservation', reservationId?: string | null, quantity?: number | null, restrictions?: { __typename?: 'Restrictions', geoCheck: GeoCheckStatus, playerCheck: PlayerCheckStatus, depositLimit?: { __typename?: 'ExceededLimit', period: LimitPeriod, type: LimitType, available: { __typename?: 'Money', currency: string, value: number }, value: { __typename?: 'Money', currency: string, value: number } } | null, spendingLimit?: { __typename?: 'ExceededLimit', period: LimitPeriod, type: LimitType, available: { __typename?: 'Money', currency: string, value: number }, value: { __typename?: 'Money', currency: string, value: number } } | null } | null } };

export type RevealScratchcardMutationVariables = Exact<{
  input: RevealScratchcardInput;
}>;


export type RevealScratchcardMutation = { __typename?: 'Mutation', revealScratchcard: { __typename?: 'WinningsPayload', isBigWin: boolean, prizeTier?: number | null, amount?: { __typename?: 'Money', currency: string, value: number } | null } };

export type RevealScratchcardOrderMutationVariables = Exact<{
  input: RevealOrderInput;
}>;


export type RevealScratchcardOrderMutation = { __typename?: 'Mutation', revealOrder: { __typename?: 'ScratchcardOrderDetail', gameName: string, orderId: string, quantity: number, quantityActive: number, state: ScratchcardState, winnings?: { __typename?: 'Money', currency: string, value: number } | null, scratchcards: Array<{ __typename?: 'ScratchcardDetail', image?: string | null, serialNumber: string, status: ScratchcardState, winningsPayload?: { __typename?: 'WinningsPayload', isBigWin: boolean, amount?: { __typename?: 'Money', currency: string, value: number } | null } | null }> } };

export type ScratchcardGameQueryVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
  slug: Scalars['String']['input'];
}>;


export type ScratchcardGameQuery = { __typename?: 'Query', scratchcardGame: { __typename?: 'ScratchcardGame', available: number, enabled: boolean, name: string, slug: string, priceList: { __typename?: 'ScratchcardPriceList', currency: string, salesTaxStrategy: string, chargePerCard: { __typename?: 'Money', currency: string, value: number }, chargePerOrder: { __typename?: 'Money', currency: string, value: number }, feePerCard: { __typename?: 'Money', currency: string, value: number }, feePerOrder: { __typename?: 'Money', currency: string, value: number } }, prizeTiers: Array<{ __typename?: 'ScratchcardPrizeTier', tier: number, prize: { __typename?: 'Money', currency: string, value: number } }>, visualParameters: { __typename?: 'ScratchcardVisualParameters', primaryColor?: string | null, secondaryColor?: string | null, teaserImage?: string | null, titleColor: string } } };

export type ScratchcardOrderQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type ScratchcardOrderQuery = { __typename?: 'Query', scratchcardOrder: { __typename?: 'ScratchcardOrderDetail', gameName: string, licensedTerritory: string, orderId: string, quantity: number, quantityActive: number, quantityRevealed: number, state: ScratchcardState, price: { __typename?: 'Money', currency: string, value: number }, scratchcards: Array<{ __typename?: 'ScratchcardDetail', image?: string | null, serialNumber: string, status: ScratchcardState, images?: { __typename?: 'ImagesPayload', back: string, backCreationDate: string, linkExpiresAt: string, scratched: string, scratchedCreationDate: string, unscratched: string, unscratchedCreationDate: string, backImageProperties: { __typename?: 'ImagePropertiesPayload', blurHash: string, height: number, width: number }, scratchedImageProperties: { __typename?: 'ImagePropertiesPayload', blurHash: string, height: number, width: number }, unscratchedImageProperties: { __typename?: 'ImagePropertiesPayload', blurHash: string, height: number, width: number } } | null, winningsPayload?: { __typename?: 'WinningsPayload', isBigWin: boolean, amount?: { __typename?: 'Money', currency: string, value: number } | null } | null }>, visualParameters: { __typename?: 'ScratchcardVisualParameters', primaryColor?: string | null, scratchArea: ScratchArea, secondaryColor?: string | null, titleColor: string }, winnings?: { __typename?: 'Money', currency: string, value: number } | null } };

export type ScratchcardTeasersQueryVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
}>;


export type ScratchcardTeasersQuery = { __typename?: 'Query', scratchcardTeasers: Array<{ __typename?: 'ScratchcardTeaser', name: string, slug: string, pricePerCard: { __typename?: 'Money', currency: string, value: number }, value: { __typename?: 'Money', currency: string, value: number }, visualParameters: { __typename?: 'ScratchcardVisualParameters', primaryColor?: string | null, secondaryColor?: string | null, teaserImage?: string | null, titleColor: string } }> };

export type ChangePreferencesMutationVariables = Exact<{
  input: PreferencesInput;
}>;


export type ChangePreferencesMutation = { __typename?: 'Mutation', setPreferences: Array<{ __typename?: 'PreferencePayload', notification: Notification, channels: Array<{ __typename?: 'ChannelPayload', channel: NotificationChannel, selected: boolean }> }> };

export type ChangeTwoFactorConfigurationMutationVariables = Exact<{
  input: TwoFactorAuthenticationChannelSettingPayloadInput;
}>;


export type ChangeTwoFactorConfigurationMutation = { __typename?: 'Mutation', changeTwoFactorConfiguration: { __typename?: 'ChangeTwoFactorConfigurationPayload', channels: Array<{ __typename?: 'TwoFactorAuthenticationChannelSettingPayload', activated: boolean, channel: TwoFactorAuthenticationChannel }> } };

export type CheckPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckPreferencesQuery = { __typename?: 'Query', preferences: Array<{ __typename?: 'PreferencePayload', notification: Notification, channels: Array<{ __typename?: 'ChannelPayload', channel: NotificationChannel, selected: boolean }> }> };

export type GetTwoFactorConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTwoFactorConfigurationQuery = { __typename?: 'Query', twoFactorConfiguration: { __typename?: 'TwoFactorConfigurationPayload', channels: Array<{ __typename?: 'TwoFactorAuthenticationChannelSettingPayload', activated: boolean, channel: TwoFactorAuthenticationChannel }> } };
